
jQuery(document).ready(function () {
	/* Disena tu cama Landing Page */
	var listado_productos = [

		{
			id: 1,
			parentid: 1,
			subparentid: null,
			defecto: false,
			nombre: '80-90 cm',
			sku: null,
			precio: null,
			premium: null,
			cat: 'cama',
			modo: 'square',
			clase: 'square',
			capa: 'bajera',
			imagen: 'Bco_Individual_Base.png'
		},
		{
			id: 2,
			parentid: 2,
			subparentid: null,
			defecto: false,
			nombre: '135-140 cm',
			sku: null,
			precio: null,
			premium: null,
			cat: 'cama',
			modo: 'square',
			clase: 'square',
			capa: 'bajera',
			imagen: 'Bco_Doble_Base.png'
		},
		{
			id: 3,
			parentid: 3,
			subparentid: null,
			defecto: false,
			nombre: '150-160 cm',
			sku: null,
			precio: null,
			premium: null,
			cat: 'cama',
			modo: 'square',
			clase: 'square',
			capa: 'bajera',
			imagen: 'Bco_Doble_Base.png'
		},
		{
			id: 4,
			parentid: 4,
			subparentid: null,
			defecto: true,
			nombre: '180-200 cm',
			sku: null,
			precio: null,
			premium: null,
			cat: 'cama',
			modo: 'square',
			clase: 'square',
			capa: 'bajera',
			imagen: 'Bco_Doble_Base.png'
		},

		{
			id: 5,
			parentid: 1,
			subparentid: null,
			defecto: true,
			nombre: 'Bajera ajustable algodón orgánico Blanco',
			sku: 'besto/90x200/bco',
			precio: 27,
			premium: 19.90,
			cat: 'bajera',
			modo: 'color',
			clase: 'bco',
			capa: 'bajera',
			imagen: 'Bco_Individual_Base.png'
		},

		{
			id: 1008,
			parentid: 1,
			subparentid: null,
			defecto: true,
			nombre: 'Bajera ajustable algodón orgánico Verde Oscuro',
			sku: 'BESTO/90X200/VOS',
			precio: 23,
			premium: 20.90,
			cat: 'bajera',
			modo: 'color',
			clase: 'gre',
			capa: 'bajera',
			imagen: 'Dark_Green_Individual_Base.png'
		},


		{
			id: 1500,
			parentid: 1,
			subparentid: null,
			defecto: false,
			nombre: 'Bajera ajustable algodón orgánico Lila Claro',
			sku: 'besto/90x20/mrr',
			precio: 28,
			premium: 24.99,
			cat: 'bajera',
			modo: 'color',
			clase: 'mrr',
			capa: 'bajera',
			imagen: 'Mar_Individual_Base.png'
		},

		{
			id: 6,
			parentid: 1,
			subparentid: null,
			defecto: false,
			nombre: 'Bajera ajustable algodón orgánico Aqua',
			sku: 'besto/90x200/aqu',
			precio: 27,
			premium: 19.90,
			cat: 'bajera',
			modo: 'color',
			clase: 'aqu',
			capa: 'bajera',
			imagen: 'Agu_Individual_Base.png'
		},
		{
			id: 7,
			parentid: 1,
			subparentid: null,
			defecto: false,
			nombre: 'Bajera ajustable algodón orgánico Amarillo',
			// sku: 'besto/90x200/ama',
			sku: 'besto/90x200/amc',
			precio: 27,
			premium: 19.90,
			cat: 'bajera',
			modo: 'color',
			clase: 'ama',
			capa: 'bajera',
			imagen: 'Amc_Individual_Base.png'
		},
		{
			id: 8,
			parentid: 1,
			subparentid: null,
			defecto: false,
			nombre: 'Bajera ajustable algodón orgánico Rosa',
			sku: 'besto/90x200/ros',
			precio: 27,
			premium: 19.90,
			cat: 'bajera',
			modo: 'color',
			clase: 'ros',
			capa: 'bajera',
			imagen: 'Ros_Individual_Base.png'
		},
		{
			id: 9,
			parentid: 1,
			subparentid: null,
			defecto: false,
			nombre: 'Bajera ajustable algodón orgánico Azul Oscuro',
			sku: 'besto/90x200/azd',
			precio: 27,
			premium: 19.90,
			cat: 'bajera',
			modo: 'color',
			clase: 'azd',
			capa: 'bajera',
			imagen: 'Azd_Individual_Base.png'
		},
		{
			id: 10,
			parentid: 1,
			subparentid: null,
			defecto: false,
			nombre: 'Bajera ajustable algodón orgánico Gris Ceniza',
			sku: 'besto/90x200/grz',
			precio: 27,
			premium: 19.90,
			cat: 'bajera',
			modo: 'color',
			clase: 'grz',
			capa: 'bajera',
			imagen: 'Grz_Individual_Base.png'
		},
		{
			id: 11,
			parentid: 1,
			subparentid: null,
			defecto: false,
			nombre: 'Bajera ajustable algodón orgánico Gris Piedra',
			sku: 'besto/90x200/pie',
			precio: 27,
			premium: 19.90,
			cat: 'bajera',
			modo: 'color',
			clase: 'pie',
			capa: 'bajera',
			imagen: 'Pie_Individual_Base.png'
		},
		{
			id: 12,
			parentid: 1,
			subparentid: null,
			defecto: false,
			nombre: 'Bajera ajustable algodón orgánico Azul',
			sku: 'besto/90x200/azc',
			precio: 27,
			premium: 19.90,
			cat: 'bajera',
			modo: 'color',
			clase: 'azc',
			capa: 'bajera',
			imagen: 'Azu_Individual_Base.png'
		},
		{
			id: 13,
			parentid: 1,
			subparentid: null,
			defecto: false,
			nombre: 'Bajera ajustable algodón orgánico Gris Ceniza Oscuro',
			sku: 'besto/90x200/cen',
			precio: 27,
			premium: 19.90,
			cat: 'bajera',
			modo: 'color',
			clase: 'cen',
			capa: 'bajera',
			imagen: 'Grc_Individual_Base.png'
		},
		{
			id: 14,
			parentid: 1,
			subparentid: null,
			defecto: false,
			nombre: 'Bajera ajustable algodón orgánico Gris Claro',
			sku: 'besto/90x200/grc',
			precio: 27,
			premium: 19.90,
			cat: 'bajera',
			modo: 'color',
			clase: 'grc',
			capa: 'bajera',
			imagen: 'Grc_2_Individual_Base.png'
		},


		{
			id: 15,
			parentid: 1,
			subparentid: null,
			defecto: true,
			nombre: 'Sábana encimera algodón orgánico Blanco',
			sku: 'besto/160x275/bco',
			precio: 30,
			premium: 21.90,
			cat: 'encimera',
			modo: 'color',
			clase: 'bco',
			capa: 'encimera',
			imagen: 'Bco_Individual_Sabana.png'
		},

		{
			id: 1004,
			parentid: 1,
			subparentid: null,
			defecto: true,
			nombre: 'Sábana encimera algodón orgánico Verde Oscuro',
			sku: 'BESTO/160X275/VOS',
			precio: 25,
			premium: 22.90,
			cat: 'encimera',
			modo: 'color',
			clase: 'gre',
			capa: 'encimera',
			imagen: 'Dark_Green_Individual_Sabana.png'
		},


		{
			id: 1508,
			parentid: 1,
			subparentid: null,
			defecto: false,
			nombre: 'Sábana encimera algodón orgánico Lila Claro',
			sku: 'besto/160x275/mrr',
			precio: 30,
			premium: 26.99,
			cat: 'encimera',
			modo: 'color',
			clase: 'mrr',
			capa: 'encimera',
			imagen: 'Mar_Individual_Sabana.png'
		},

		{
			id: 16,
			parentid: 1,
			subparentid: null,
			defecto: false,
			nombre: 'Sábana encimera algodón orgánico Aqua',
			sku: 'besto/160x275/aqu',
			precio: 30,
			premium: 21.90,
			cat: 'encimera',
			modo: 'color',
			clase: 'aqu',
			capa: 'encimera',
			imagen: 'Agu_Individual_Sabana.png'
		},
		{
			id: 17,
			parentid: 1,
			subparentid: null,
			defecto: false,
			nombre: 'Sábana encimera algodón orgánico Amarillo',
			// sku: 'besto/160x275/ama',
			sku: 'besto/160x275/amc',
			precio: 30,
			premium: 21.90,
			cat: 'encimera',
			modo: 'color',
			clase: 'ama',
			capa: 'encimera',
			imagen: 'Amc_Individual_Sabana.png'
		},
		{
			id: 18,
			parentid: 1,
			subparentid: null,
			defecto: false,
			nombre: 'Sábana encimera algodón orgánico Rosa',
			sku: 'besto/160x275/ros',
			precio: 30,
			premium: 21.90,
			cat: 'encimera',
			modo: 'color',
			clase: 'ros',
			capa: 'encimera',
			imagen: 'Ros_Individual_Sabana.png'
		},
		{
			id: 19,
			parentid: 1,
			subparentid: null,
			defecto: false,
			nombre: 'Sábana encimera algodón orgánico Azul Oscuro',
			sku: 'besto/160x275/azd',
			precio: 30,
			premium: 21.90,
			cat: 'encimera',
			modo: 'color',
			clase: 'azd',
			capa: 'encimera',
			imagen: 'Azd_Individual_Sabana.png'
		},
		{
			id: 20,
			parentid: 1,
			subparentid: null,
			defecto: false,
			nombre: 'Sábana encimera algodón orgánico Gris Ceniza Oscuro',
			sku: 'besto/160x275/cen',
			precio: 30,
			premium: 21.90,
			cat: 'encimera',
			modo: 'color',
			clase: 'grz',
			capa: 'encimera',
			imagen: 'Grz_Individual_Sabana.png'
		},
		{
			id: 21,
			parentid: 1,
			subparentid: null,
			defecto: false,
			nombre: 'Sábana encimera algodón orgánico Gris Piedra',
			sku: 'besto/160x275/pie',
			precio: 30,
			premium: 21.90,
			cat: 'encimera',
			modo: 'color',
			clase: 'pie',
			capa: 'encimera',
			imagen: 'Pie_Individual_Sabana.png'
		},
		{
			id: 22,
			parentid: 1,
			subparentid: null,
			defecto: false,
			nombre: 'Sábana encimera algodón orgánico Azul',
			sku: 'besto/160x275/azu',
			precio: 30,
			premium: 21.90,
			cat: 'encimera',
			modo: 'color',
			clase: 'azu',
			capa: 'encimera',
			imagen: 'Azu_Individual_Sabana.png'
		},
		{
			id: 23,
			parentid: 1,
			subparentid: null,
			defecto: false,
			nombre: 'Sábana encimera algodón orgánico Gris Claro',
			sku: 'besto/160x275/grz',
			precio: 30,
			premium: 21.90,
			cat: 'encimera',
			modo: 'color',
			clase: 'cen',
			capa: 'encimera',
			imagen: 'Grc_Individual_Sabana.png'
		},

		{
			id: 25,
			parentid: 1,
			subparentid: null,
			defecto: true,
			nombre: 'Funda nórdica algodón orgánico Blanco',
			sku: 'besto/150x260/bco',
			precio: 47,
			premium: 34.90,
			cat: 'funda',
			modo: 'color',
			clase: 'bco',
			capa: 'funda',
			imagen: 'Bco_Individual_Nordico.png'
		},

		{
			id: 1000,
			parentid: 1,
			subparentid: null,
			defecto: true,
			nombre: 'Funda nórdica algodón orgánico Verde Oscuro',
			sku: 'BESTO-FNORD-A',
			precio: 40,
			premium: 35.90,
			cat: 'funda',
			modo: 'color',
			clase: 'gre',
			capa: 'funda',
			imagen: 'Dark_Green_Individual_Nordico.png'
		},

		{
			id: 1504,
			parentid: 1,
			subparentid: null,
			defecto: false,
			nombre: 'Funda nórdica algodón orgánico Lila Claro',
			sku: 'bestobic/150x260/mrr',
			precio: 44,
			premium: 39.99,
			cat: 'funda',
			modo: 'color',
			clase: 'mrr',
			capa: 'funda',
			imagen: 'Mar_Individual_Nordico.png'
		},

		{
			id: 26,
			parentid: 1,
			subparentid: null,
			defecto: false,
			nombre: 'Funda nórdica algodón orgánico Aqua',
			sku: 'besto/150x260/aqu',
			precio: 47,
			premium: 34.90,
			cat: 'funda',
			modo: 'color',
			clase: 'aqu',
			capa: 'funda',
			imagen: 'Agu_Individual_Nordico.png'
		},
		{
			id: 27,
			parentid: 1,
			subparentid: null,
			defecto: false,
			nombre: 'Funda nórdica algodón orgánico Amarillo',
			//sku: 'besto/150x260/ama',
			sku: 'besto/150x260/amc',
			precio: 47,
			premium: 34.90,
			cat: 'funda',
			modo: 'color',
			clase: 'ama',
			capa: 'funda',
			imagen: 'Amc_Individual_Nordico.png'
		},
		{
			id: 28,
			parentid: 1,
			subparentid: null,
			defecto: false,
			nombre: 'Funda nórdica algodón orgánico Rosa',
			sku: 'besto/150x260/ros',
			precio: 47,
			premium: 34.90,
			cat: 'funda',
			modo: 'color',
			clase: 'ros',
			capa: 'funda',
			imagen: 'Ros_Individual_Nordico.png'
		},
		{
			id: 29,
			parentid: 1,
			subparentid: null,
			defecto: false,
			nombre: 'Funda nórdica algodón orgánico Azul Oscuro',
			sku: 'besto/150x260/azd',
			precio: 47,
			premium: 34.90,
			cat: 'funda',
			modo: 'color',
			clase: 'azd',
			capa: 'funda',
			imagen: 'Azd_Individual_Nordico.png'
		},
		{
			id: 30,
			parentid: 1,
			subparentid: null,
			defecto: false,
			nombre: 'Funda nórdica algodón orgánico Gris Ceniza',
			sku: 'besto/150x260/cen',
			precio: 47,
			premium: 34.90,
			cat: 'funda',
			modo: 'color',
			clase: 'grz',
			capa: 'funda',
			imagen: 'Grz_Individual_Nordico.png'
		},
		{
			id: 31,
			parentid: 1,
			subparentid: null,
			defecto: false,
			nombre: 'Funda nórdica algodón orgánico Gris Piedra',
			sku: 'bestobic/150x260/pie',
			precio: 47,
			premium: 34.90,
			cat: 'funda',
			modo: 'color',
			clase: 'piedoble',
			capa: 'funda',
			imagen: 'Pie_Individual_Nordico.png'
		},
		{
			id: 32,
			parentid: 1,
			subparentid: null,
			defecto: false,
			nombre: 'Funda nórdica algodón orgánico Azul',
			sku: 'bestobic/150x260/azc',
			precio: 47,
			premium: 34.90,
			cat: 'funda',
			modo: 'color',
			clase: 'azudoble',
			capa: 'funda',
			imagen: 'Azu_Individual_Nordico.png'
		},
		{
			id: 33,
			parentid: 1,
			subparentid: null,
			defecto: false,
			nombre: 'Funda nórdica algodón orgánico Gris Claro',
			sku: 'bestobic/150x260/grc',
			precio: 47,
			premium: 34.90,
			cat: 'funda',
			modo: 'color',
			clase: 'grcdoble',
			capa: 'funda',
			imagen: 'Grc_Individual_Nordico.png'
		},


		{
			id: 34,
			parentid: 2,
			subparentid: null,
			defecto: true,
			nombre: 'Bajera ajustable algodón orgánico Blanco',
			sku: 'besto/135x200/bco',
			precio: 33,
			premium: 23.90,
			cat: 'bajera',
			modo: 'color',
			clase: 'bco',
			capa: 'bajera',
			imagen: 'Bco_Doble_Base.png'
		},

		{
			id: 1009,
			parentid: 2,
			subparentid: null,
			defecto: true,
			nombre: 'Bajera ajustable algodón orgánico Verde Oscuro',
			sku: 'BESTO/135X200/VOS',
			precio: 27,
			premium: 23.90,
			cat: 'bajera',
			modo: 'color',
			clase: 'gre',
			capa: 'bajera',
			imagen: 'Dark_Green_Doble_Base.png'
		},


		{
			id: 1501,
			parentid: 2,
			subparentid: null,
			defecto: false,
			nombre: 'Bajera ajustable algodón orgánico Lila Claro',
			sku: 'besto/135x200/mrr',
			precio: 31,
			premium: 27.99,
			cat: 'bajera',
			modo: 'color',
			clase: 'mrr',
			capa: 'bajera',
			imagen: 'Mar_Doble_Base.png'
		},

		{
			id: 35,
			parentid: 2,
			subparentid: null,
			defecto: false,
			nombre: 'Bajera ajustable algodón orgánico Aqua',
			sku: 'besto/135x200/aqu',
			precio: 33,
			premium: 23.90,
			cat: 'bajera',
			modo: 'color',
			clase: 'aqu',
			capa: 'bajera',
			imagen: 'Agu_Doble_Base.png'
		},
		{
			id: 36,
			parentid: 2,
			subparentid: null,
			defecto: false,
			nombre: 'Bajera ajustable algodón orgánico Amarillo',
			// sku: 'BESTO/135X200/ama',
			sku: 'BESTO/135X200/amc',
			precio: 33,
			premium: 23.90,
			cat: 'bajera',
			modo: 'color',
			clase: 'ama',
			capa: 'bajera',
			imagen: 'Amc_Doble_Base.png'
		},
		{
			id: 37,
			parentid: 2,
			subparentid: null,
			defecto: false,
			nombre: 'Bajera ajustable algodón orgánico Rosa',
			sku: 'besto/135x200/ros',
			precio: 33,
			premium: 23.90,
			cat: 'bajera',
			modo: 'color',
			clase: 'ros',
			capa: 'bajera',
			imagen: 'Ros_Doble_Base.png'
		},
		{
			id: 38,
			parentid: 2,
			subparentid: null,
			defecto: false,
			nombre: 'Bajera ajustable algodón orgánico Azul Oscuro',
			sku: 'besto/135x200/azd',
			precio: 33,
			premium: 23.90,
			cat: 'bajera',
			modo: 'color',
			clase: 'azd',
			capa: 'bajera',
			imagen: 'Azd_Doble_Base.png'
		},
		{
			id: 39,
			parentid: 2,
			subparentid: null,
			defecto: false,
			nombre: 'Bajera ajustable algodón orgánico Gris Ceniza Oscuro',
			sku: 'besto/135x200/cen',
			precio: 33,
			premium: 23.90,
			cat: 'bajera',
			modo: 'color',
			clase: 'grz',
			capa: 'bajera',
			imagen: 'Grz_Doble_Base.png'
		},
		{
			id: 40,
			parentid: 2,
			subparentid: null,
			defecto: false,
			nombre: 'Bajera ajustable algodón orgánico Gris Piedra',
			sku: 'besto/135x200/pie',
			precio: 33,
			premium: 23.90,
			cat: 'bajera',
			modo: 'color',
			clase: 'pie',
			capa: 'bajera',
			imagen: 'Pie_Doble_Base.png'
		},
		{
			id: 41,
			parentid: 2,
			subparentid: null,
			defecto: false,
			nombre: 'Bajera ajustable algodón orgánico Azul',
			sku: 'besto/135x200/azc',
			precio: 33,
			premium: 23.90,
			cat: 'bajera',
			modo: 'color',
			clase: 'azc',
			capa: 'bajera',
			imagen: 'Azu_Doble_Base.png'
		},
		{
			id: 42,
			parentid: 2,
			subparentid: null,
			defecto: false,
			nombre: 'Bajera ajustable algodón orgánico Gris Ceniza',
			sku: 'besto/135x200/grz',
			precio: 33,
			premium: 23.90,
			cat: 'bajera',
			modo: 'color',
			clase: 'cen',
			capa: 'bajera',
			imagen: 'Grc_Doble_Base.png'
		},
		{
			id: 43,
			parentid: 2,
			subparentid: null,
			defecto: false,
			nombre: 'Bajera ajustable algodón orgánico Gris Claro',
			sku: 'besto/135x200/grc',
			precio: 33,
			premium: 23.90,
			cat: 'bajera',
			modo: 'color',
			clase: 'grc',
			capa: 'bajera',
			imagen: 'Grc_2_Doble_Base.png'
		},


		{
			id: 44,
			parentid: 2,
			subparentid: null,
			defecto: true,
			nombre: 'Sábana encimera algodón orgánico Blanco',
			sku: 'besto/210x275/bco',
			precio: 38,
			premium: 27.90,
			cat: 'encimera',
			modo: 'color',
			clase: 'bco',
			capa: 'encimera',
			imagen: 'Bco_Doble_Sabana.png'
		},

		{
			id: 1005,
			parentid: 2,
			subparentid: null,
			defecto: true,
			nombre: 'Sábana encimera algodón orgánico Verde Oscuro',
			sku: 'BESTO/210X275/VOS',
			precio: 31,
			premium: 27.90,
			cat: 'encimera',
			modo: 'color',
			clase: 'gre',
			capa: 'encimera',
			imagen: 'Dark_Green_Doble_Sabana.png'
		},


		{
			id: 1509,
			parentid: 2,
			subparentid: null,
			defecto: false,
			nombre: 'Sábana encimera algodón orgánico Gris Ceniza Oscuro',
			sku: 'besto/210x275/mrr',
			precio: 36,
			premium: 32.99,
			cat: 'encimera',
			modo: 'color',
			clase: 'mrr',
			capa: 'encimera',
			imagen: 'Mar_Doble_Sabana.png'
		},

		{
			id: 45,
			parentid: 2,
			subparentid: null,
			defecto: false,
			nombre: 'Sábana encimera algodón orgánico Aqua',
			sku: 'besto/210x275/aqu',
			precio: 38,
			premium: 27.90,
			cat: 'encimera',
			modo: 'color',
			clase: 'aqu',
			capa: 'encimera',
			imagen: 'Agu_Doble_Sabana.png'
		},
		{
			id: 46,
			parentid: 2,
			subparentid: null,
			defecto: false,
			nombre: 'Sábana encimera algodón orgánico Gris Ceniza Amarillo',
			// sku: 'besto/210x275/ama',
			sku: 'besto/210x275/amc',
			precio: 38,
			premium: 27.90,
			cat: 'encimera',
			modo: 'color',
			clase: 'ama',
			capa: 'encimera',
			imagen: 'Amc_Doble_Sabana.png'
		},
		{
			id: 47,
			parentid: 2,
			subparentid: null,
			defecto: false,
			nombre: 'Sábana encimera algodón orgánico Rosa',
			sku: 'besto/210x275/ros',
			precio: 38,
			premium: 27.90,
			cat: 'encimera',
			modo: 'color',
			clase: 'ros',
			capa: 'encimera',
			imagen: 'Ros_Doble_Sabana.png'
		},
		{
			id: 48,
			parentid: 2,
			subparentid: null,
			defecto: false,
			nombre: 'Sábana encimera algodón orgánico Azul Oscuro',
			sku: 'besto/210x275/azd',
			precio: 38,
			premium: 27.90,
			cat: 'encimera',
			modo: 'color',
			clase: 'azd',
			capa: 'encimera',
			imagen: 'Azd_Doble_Sabana.png'
		},

		{
			id: 49,
			parentid: 2,
			subparentid: null,
			defecto: false,
			nombre: 'Sábana encimera algodón orgánico Gris Claro',
			sku: 'besto/210x275/cen',
			precio: 38,
			premium: 27.90,
			cat: 'encimera',
			modo: 'color',
			clase: 'grz',
			capa: 'encimera',
			imagen: 'Grz_Doble_Sabana.png'
		},
		{
			id: 50,
			parentid: 2,
			subparentid: null,
			defecto: false,
			nombre: 'Sábana encimera algodón orgánico Gris Piedra',
			sku: 'besto/210x275/pie',
			precio: 38,
			premium: 27.90,
			cat: 'encimera',
			modo: 'color',
			clase: 'pie',
			capa: 'encimera',
			imagen: 'Pie_Doble_Sabana.png'
		},

		{
			id: 51,
			parentid: 2,
			subparentid: null,
			defecto: false,
			nombre: 'Sábana encimera algodón orgánico Azul',
			sku: 'besto/210x275/azu',
			precio: 38,
			premium: 27.90,
			cat: 'encimera',
			modo: 'color',
			clase: 'azu',
			capa: 'encimera',
			imagen: 'Azu_Doble_Sabana.png'
		},
		{
			id: 52,
			parentid: 2,
			subparentid: null,
			defecto: false,
			nombre: 'Sábana encimera algodón orgánico Gris Ceniza Oscuro',
			sku: 'besto/210x275/grz',
			precio: 38,
			premium: 27.90,
			cat: 'encimera',
			modo: 'color',
			clase: 'cen',
			capa: 'encimera',
			imagen: 'Grc_Doble_Sabana.png'
		},
		{
			id: 53,
			parentid: 2,
			subparentid: null,
			defecto: true,
			nombre: 'Funda nórdica algodón orgánico Blanco',
			sku: 'besto/220x260/bco',
			precio: 64,
			premium: 46.90,
			cat: 'funda',
			modo: 'color',
			clase: 'bco',
			capa: 'funda',
			imagen: 'Bco_Doble_Nordico.png'
		},

		{
			id: 1001,
			parentid: 2,
			subparentid: null,
			defecto: true,
			nombre: 'Funda nórdica algodón orgánico Verde Oscuro',
			sku: 'BESTO/220X260/VOS',
			precio: 52,
			premium: 46.90,
			cat: 'funda',
			modo: 'color',
			clase: 'gre',
			capa: 'funda',
			imagen: 'Dark_Green_Doble_Nordico.png'
		},


		{
			id: 1505,
			parentid: 2,
			subparentid: null,
			defecto: false,
			nombre: 'Funda nórdica algodón orgánico lila Claro',
			sku: 'bestobic/220x260/mrr',
			precio: 58,
			premium: 52.99,
			cat: 'funda',
			modo: 'color',
			clase: 'mrr',
			capa: 'funda',
			imagen: 'Mar_Doble_Nordico.png'
		},


		{
			id: 54,
			parentid: 2,
			subparentid: null,
			defecto: false,
			nombre: 'Funda nórdica algodón orgánico Aqua',
			sku: 'besto/220x260/aqu',
			precio: 64,
			premium: 46.90,
			cat: 'funda',
			modo: 'color',
			clase: 'aqu',
			capa: 'funda',
			imagen: 'Agu_Doble_Nordico.png'
		},
		{
			id: 55,
			parentid: 2,
			subparentid: null,
			defecto: false,
			nombre: 'Funda nórdica algodón orgánico Amarillo',
			// sku: 'besto/220x260/ama',
			sku: 'besto/220x260/amc',
			precio: 64,
			premium: 46.90,
			cat: 'funda',
			modo: 'color',
			clase: 'ama',
			capa: 'funda',
			imagen: 'Amc_Doble_Nordico.png'
		},
		{
			id: 56,
			parentid: 2,
			subparentid: null,
			defecto: false,
			nombre: 'Funda nórdica algodón orgánico Rosa',
			sku: 'besto/220x260/ros',
			precio: 64,
			premium: 46.90,
			cat: 'funda',
			modo: 'color',
			clase: 'ros',
			capa: 'funda',
			imagen: 'Ros_Doble_Nordico.png'
		},
		{
			id: 57,
			parentid: 2,
			subparentid: null,
			defecto: false,
			nombre: 'Funda nórdica algodón orgánico Azul Oscuro',
			sku: 'besto/220x260/azd',
			precio: 64,
			premium: 46.90,
			cat: 'funda',
			modo: 'color',
			clase: 'azd',
			capa: 'funda',
			imagen: 'Azd_Doble_Nordico.png'
		},
		{
			id: 58,
			parentid: 2,
			subparentid: null,
			defecto: false,
			nombre: 'Funda nórdica algodón orgánico Gris Ceniza',
			sku: 'besto/220x260/cen',
			precio: 64,
			premium: 46.90,
			cat: 'funda',
			modo: 'color',
			clase: 'grz',
			capa: 'funda',
			imagen: 'Grz_Doble_Nordico.png'
		},
		{
			id: 59,
			parentid: 2,
			subparentid: null,
			defecto: false,
			nombre: 'Funda nórdica algodón orgánico Gris Piedra',
			sku: 'bestobic/220x260/pie',
			precio: 64,
			premium: 46.90,
			cat: 'funda',
			modo: 'color',
			clase: 'piedoble',
			capa: 'funda',
			imagen: 'Pie_Doble_Nordico.png'
		},
		{
			id: 60,
			parentid: 2,
			subparentid: null,
			defecto: false,
			nombre: 'Funda nórdica algodón orgánico Azul',
			sku: 'besto/220x260/azc',
			precio: 64,
			premium: 46.90,
			cat: 'funda',
			modo: 'color',
			clase: 'azudoble',
			capa: 'funda',
			imagen: 'Azu_Doble_Nordico.png'
		},
		{
			id: 61,
			parentid: 2,
			subparentid: null,
			defecto: false,
			nombre: 'Funda nórdica algodón orgánico Gris Claro',
			sku: 'bestobic/220x260/grc',
			precio: 64,
			premium: 46.90,
			cat: 'funda',
			modo: 'color',
			clase: 'grcdoble',
			capa: 'funda',
			imagen: 'Grc_Doble_Nordico.png'
		},

		{
			id: 62,
			parentid: 3,
			subparentid: null,
			defecto: true,
			nombre: 'Bajera ajustable algodón orgánico Blanco',
			sku: 'besto/150x200/bco',
			precio: 34,
			premium: 24.90,
			cat: 'bajera',
			modo: 'color',
			clase: 'bco',
			capa: 'bajera',
			imagen: 'Bco_Doble_Base.png'
		},

		{
			id: 1010,
			parentid: 3,
			subparentid: null,
			defecto: true,
			nombre: 'Bajera ajustable algodón orgánico Verde Oscuro',
			sku: 'BESTO/150X200/VOS',
			precio: 29,
			premium: 25.90,
			cat: 'bajera',
			modo: 'color',
			clase: 'gre',
			capa: 'bajera',
			imagen: 'Dark_Green_Doble_Base.png'
		},


		{
			id: 1502,
			parentid: 3,
			subparentid: null,
			defecto: false,
			nombre: 'Bajera ajustable algodón orgánico Lila Claro',
			sku: 'besto/150x200/mrr',
			precio: 33,
			premium: 29.99,
			cat: 'bajera',
			modo: 'color',
			clase: 'mrr',
			capa: 'bajera',
			imagen: 'Mar_Doble_Base.png'
		},


		{
			id: 63,
			parentid: 3,
			subparentid: null,
			defecto: false,
			nombre: 'Bajera ajustable algodón orgánico Aqua',
			sku: 'besto/150x200/aqu',
			precio: 34,
			premium: 24.90,
			cat: 'bajera',
			modo: 'color',
			clase: 'aqu',
			capa: 'bajera',
			imagen: 'Agu_Doble_Base.png'
		},
		{
			id: 64,
			parentid: 3,
			subparentid: null,
			defecto: false,
			nombre: 'Bajera ajustable algodón orgánico Amarillo',
			// sku: 'BESTO/150X200/ama',
			sku: 'BESTO/150X200/amc',
			precio: 34,
			premium: 24.90,
			cat: 'bajera',
			modo: 'color',
			clase: 'ama',
			capa: 'bajera',
			imagen: 'Amc_Doble_Base.png'
		},
		{
			id: 65,
			parentid: 3,
			subparentid: null,
			defecto: false,
			nombre: 'Bajera ajustable algodón orgánico Rosa',
			sku: 'besto/150x200/ros',
			precio: 34,
			premium: 24.90,
			cat: 'bajera',
			modo: 'color',
			clase: 'ros',
			capa: 'bajera',
			imagen: 'Ros_Doble_Base.png'
		},
		{
			id: 66,
			parentid: 3,
			subparentid: null,
			defecto: false,
			nombre: 'Bajera ajustable algodón orgánico Azul Oscuro',
			sku: 'besto/150x200/azd',
			precio: 34,
			premium: 24.90,
			cat: 'bajera',
			modo: 'color',
			clase: 'azd',
			capa: 'bajera',
			imagen: 'Azd_Doble_Base.png'
		},
		{
			id: 67,
			parentid: 3,
			subparentid: null,
			defecto: false,
			nombre: 'Bajera ajustable algodón orgánico Gris Ceniza Oscuro',
			sku: 'besto/150x200/cen',
			precio: 34,
			premium: 24.90,
			cat: 'bajera',
			modo: 'color',
			clase: 'grz',
			capa: 'bajera',
			imagen: 'Grz_Doble_Base.png'
		},
		{
			id: 68,
			parentid: 3,
			subparentid: null,
			defecto: false,
			nombre: 'Bajera ajustable algodón orgánico Gris Piedra',
			sku: 'besto/150x200/pie',
			precio: 34,
			premium: 24.90,
			cat: 'bajera',
			modo: 'color',
			clase: 'pie',
			capa: 'bajera',
			imagen: 'Pie_Doble_Base.png'
		},
		{
			id: 69,
			parentid: 3,
			subparentid: null,
			defecto: false,
			nombre: 'Bajera ajustable algodón orgánico Azul',
			sku: 'besto/150x200/azc',
			precio: 34,
			premium: 24.90,
			cat: 'bajera',
			modo: 'color',
			clase: 'azc',
			capa: 'bajera',
			imagen: 'Azu_Doble_Base.png'
		},
		{
			id: 70,
			parentid: 3,
			subparentid: null,
			defecto: false,
			nombre: 'Bajera ajustable algodón orgánico Gris Ceniza',
			sku: 'besto/150x200/grz',
			precio: 34,
			premium: 24.90,
			cat: 'bajera',
			modo: 'color',
			clase: 'cen',
			capa: 'bajera',
			imagen: 'Grc_Doble_Base.png'
		},
		{
			id: 71,
			parentid: 3,
			subparentid: null,
			defecto: false,
			nombre: 'Bajera ajustable algodón orgánico Gris Claro',
			sku: 'besto/150x200/grc',
			precio: 34,
			premium: 24.90,
			cat: 'bajera',
			modo: 'color',
			clase: 'grc',
			capa: 'bajera',
			imagen: 'Grc_2_Doble_Base.png'
		},


		{
			id: 72,
			parentid: 3,
			subparentid: null,
			defecto: true,
			nombre: 'Sábana encimera algodón orgánico Blanco',
			sku: 'besto/240x275/bco',
			precio: 41,
			premium: 29.90,
			cat: 'encimera',
			modo: 'color',
			clase: 'bco',
			capa: 'encimera',
			imagen: 'Bco_Doble_Sabana.png'
		},

		{
			id: 1006,
			parentid: 3,
			subparentid: null,
			defecto: true,
			nombre: 'Sábana encimera algodón orgánico Verde Oscuro',
			sku: 'BESTO/240X275/VOS',
			precio: 34,
			premium: 30.90,
			cat: 'encimera',
			modo: 'color',
			clase: 'gre',
			capa: 'encimera',
			imagen: 'Dark_Green_Doble_Sabana.png'
		},

		{
			id: 1510,
			parentid: 3,
			subparentid: null,
			defecto: false,
			nombre: 'Sábana encimera algodón orgánico Lila Claro',
			sku: 'besto/240x275/mrr',
			precio: 40,
			premium: 35.99,
			cat: 'encimera',
			modo: 'color',
			clase: 'mrr',
			capa: 'encimera',
			imagen: 'Mar_Doble_Sabana.png'
		},

		{
			id: 73,
			parentid: 3,
			subparentid: null,
			defecto: false,
			nombre: 'Sábana encimera algodón orgánico Aqua',
			sku: 'besto/240x275/aqu',
			precio: 41,
			premium: 29.90,
			cat: 'encimera',
			modo: 'color',
			clase: 'aqu',
			capa: 'encimera',
			imagen: 'Agu_Doble_Sabana.png'
		},
		{
			id: 74,
			parentid: 3,
			subparentid: null,
			defecto: false,
			nombre: 'Sábana encimera algodón orgánico Amarillo',
			// sku: 'besto/240x275/ama',
			sku: 'besto/240x275/amc',
			precio: 41,
			premium: 29.90,
			cat: 'encimera',
			modo: 'color',
			clase: 'ama',
			capa: 'encimera',
			imagen: 'Amc_Doble_Sabana.png'
		},
		{
			id: 75,
			parentid: 3,
			subparentid: null,
			defecto: false,
			nombre: 'Sábana encimera algodón orgánico Rosa',
			sku: 'besto/240x275/ros',
			precio: 41,
			premium: 29.90,
			cat: 'encimera',
			modo: 'color',
			clase: 'ros',
			capa: 'encimera',
			imagen: 'Ros_Doble_Sabana.png'
		},
		{
			id: 76,
			parentid: 3,
			subparentid: null,
			defecto: false,
			nombre: 'Sábana encimera algodón orgánico Azul Oscuro',
			sku: 'besto/240x275/azd',
			precio: 41,
			premium: 29.90,
			cat: 'encimera',
			modo: 'color',
			clase: 'azd',
			capa: 'encimera',
			imagen: 'Azd_Doble_Sabana.png'
		},
		{
			id: 77,
			parentid: 3,
			subparentid: null,
			defecto: false,
			nombre: 'Sábana encimera algodón orgánico Gris Ceniza Oscuro',
			sku: 'besto/240x275/cen',
			precio: 41,
			premium: 29.90,
			cat: 'encimera',
			modo: 'color',
			clase: 'grz',
			capa: 'encimera',
			imagen: 'Grz_Doble_Sabana.png'
		},
		{
			id: 78,
			parentid: 3,
			subparentid: null,
			defecto: false,
			nombre: 'Sábana encimera algodón orgánico Gris Piedra',
			sku: 'besto/240x275/pie',
			precio: 41,
			premium: 29.90,
			cat: 'encimera',
			modo: 'color',
			clase: 'pie',
			capa: 'encimera',
			imagen: 'Pie_Doble_Sabana.png'
		},
		{
			id: 79,
			parentid: 3,
			subparentid: null,
			defecto: false,
			nombre: 'Sábana encimera algodón orgánico Azul',
			sku: 'besto/240x275/azu',
			precio: 41,
			premium: 29.90,
			cat: 'encimera',
			modo: 'color',
			clase: 'azc',
			capa: 'encimera',
			imagen: 'Azu_Doble_Sabana.png'
		},

		{
			id: 80,
			parentid: 3,
			subparentid: null,
			defecto: false,
			nombre: 'Sábana encimera algodón orgánico Gris Claro',
			sku: 'besto/240x275/grz',
			precio: 41,
			premium: 29.90,
			cat: 'encimera',
			modo: 'color',
			clase: 'cen',
			capa: 'encimera',
			imagen: 'Grc_Doble_Sabana.png'
		},

		{
			id: 81,
			parentid: 3,
			subparentid: null,
			defecto: true,
			nombre: 'Funda nórdica algodón orgánico Blanco',
			sku: 'besto/240x260/bco',
			precio: 68,
			premium: 49.90,
			cat: 'funda',
			modo: 'color',
			clase: 'bco',
			capa: 'funda',
			imagen: 'Bco_Doble_Nordico.png'
		},

		{
			id: 1002,
			parentid: 3,
			subparentid: null,
			defecto: true,
			nombre: 'Funda nórdica algodón orgánico Verde Oscuro',
			sku: 'BESTO/240X260/VOS',
			precio: 56,
			premium: 50.90,
			cat: 'funda',
			modo: 'color',
			clase: 'gre',
			capa: 'funda',
			imagen: 'Dark_Green_Doble_Nordico.png'
		},

		{
			id: 1506,
			parentid: 3,
			subparentid: null,
			defecto: false,
			nombre: 'Funda nórdica algodón orgánico Lila Claro',
			sku: 'bestobic/240x260/mrr',
			precio: 63,
			premium: 56.99,
			cat: 'funda',
			modo: 'color',
			clase: 'mrr',
			capa: 'funda',
			imagen: 'Mar_Doble_Nordico.png'
		},

		{
			id: 82,
			parentid: 3,
			subparentid: null,
			defecto: false,
			nombre: 'Funda nórdica algodón orgánico Aqua',
			sku: 'besto/240x260/aqu',
			precio: 68,
			premium: 49.90,
			cat: 'funda',
			modo: 'color',
			clase: 'aqu',
			capa: 'funda',
			imagen: 'Agu_Doble_Nordico.png'
		},
		{
			id: 83,
			parentid: 3,
			subparentid: null,
			defecto: false,
			nombre: 'Funda nórdica algodón orgánico Amarillo',
			// sku: 'besto/240x260/ama',
			sku: 'besto/240x260/amc',
			precio: 68,
			premium: 49.90,
			cat: 'funda',
			modo: 'color',
			clase: 'ama',
			capa: 'funda',
			imagen: 'Amc_Doble_Nordico.png'
		},
		{
			id: 84,
			parentid: 3,
			subparentid: null,
			defecto: false,
			nombre: 'Funda nórdica algodón orgánico Rosa',
			sku: 'besto/240x260/ros',
			precio: 68,
			premium: 49.90,
			cat: 'funda',
			modo: 'color',
			clase: 'ros',
			capa: 'funda',
			imagen: 'Ros_Doble_Nordico.png'
		},
		{
			id: 85,
			parentid: 3,
			subparentid: null,
			defecto: false,
			nombre: 'Funda nórdica algodón orgánico Azul Oscuro',
			sku: 'besto/240x260/azd',
			precio: 68,
			premium: 49.90,
			cat: 'funda',
			modo: 'color',
			clase: 'azd',
			capa: 'funda',
			imagen: 'Azd_Doble_Nordico.png'
		},
		{
			id: 86,
			parentid: 3,
			subparentid: null,
			defecto: false,
			nombre: 'Funda nórdica algodón orgánico Gris Ceniza',
			sku: 'besto/240x260/cen',
			precio: 68,
			premium: 49.90,
			cat: 'funda',
			modo: 'color',
			clase: 'grz',
			capa: 'funda',
			imagen: 'Grz_Doble_Nordico.png'
		},
		{
			id: 87,
			parentid: 3,
			subparentid: null,
			defecto: false,
			nombre: 'Funda nórdica algodón orgánico Gris Piedra',
			sku: 'bestobic/240x260/pie',
			precio: 68,
			premium: 49.90,
			cat: 'funda',
			modo: 'color',
			clase: 'piedoble',
			capa: 'funda',
			imagen: 'Pie_Doble_Nordico.png'
		},
		{
			id: 88,
			parentid: 3,
			subparentid: null,
			defecto: false,
			nombre: 'Funda nórdica algodón orgánico Azul',
			sku: 'bestobic/240x260/azc',
			precio: 68,
			premium: 49.90,
			cat: 'funda',
			modo: 'color',
			clase: 'azudoble',
			capa: 'funda',
			imagen: 'Azu_Doble_Nordico.png'
		},

		{
			id: 89,
			parentid: 3,
			subparentid: null,
			defecto: false,
			nombre: 'Funda nórdica algodón orgánico Gris Claro',
			sku: 'bestobic/240x260/grc',
			precio: 68,
			premium: 49.90,
			cat: 'funda',
			modo: 'color',
			clase: 'grcdoble',
			capa: 'funda',
			imagen: 'Grc_2_Doble_Nordico.png'
		},
		{
			id: 90,
			parentid: 4,
			subparentid: null,
			defecto: true,
			nombre: 'Bajera ajustable algodón orgánico Blanco',
			sku: 'besto/180x200/bco',
			precio: 38,
			premium: 27.90,
			cat: 'bajera',
			modo: 'color',
			clase: 'bco',
			capa: 'bajera',
			imagen: 'Bco_Doble_Base.png'
		},

		{
			id: 1011,
			parentid: 4,
			subparentid: null,
			defecto: true,
			nombre: 'Bajera ajustable algodón orgánico Verde Oscuro',
			sku: 'BESTO/180X200/VOS',
			precio: 31,
			premium: 27.90,
			cat: 'bajera',
			modo: 'color',
			clase: 'gre',
			capa: 'bajera',
			imagen: 'Dark_Green_Doble_Base.png'
		},

		{
			id: 1503,
			parentid: 4,
			subparentid: null,
			defecto: false,
			nombre: 'Bajera ajustable algodón orgánico Lic Claro',
			sku: 'besto/180x200/mrr',
			precio: 36,
			premium: 32.99,
			cat: 'bajera',
			modo: 'color',
			clase: 'mrr',
			capa: 'bajera',
			imagen: 'Mar_Doble_Base.png'
		},

		{
			id: 91,
			parentid: 4,
			subparentid: null,
			defecto: false,
			nombre: 'Bajera ajustable algodón orgánico Aqua',
			sku: 'besto/180x200/aqu',
			precio: 38,
			premium: 27.90,
			cat: 'bajera',
			modo: 'color',
			clase: 'aqu',
			capa: 'bajera',
			imagen: 'Agu_Doble_Base.png'
		},
		{
			id: 92,
			parentid: 4,
			subparentid: null,
			defecto: false,
			nombre: 'Bajera ajustable algodón orgánico Amarillo',
			//sku: 'besto/180x200/ama',
			sku: 'besto/180x200/amc',
			precio: 38,
			premium: 27.90,
			cat: 'bajera',
			modo: 'color',
			clase: 'ama',
			capa: 'bajera',
			imagen: 'Amc_Doble_Base.png'
		},
		{
			id: 93,
			parentid: 4,
			subparentid: null,
			defecto: false,
			nombre: 'Bajera ajustable algodón orgánico Rosa',
			sku: 'besto/180x200/ros',
			precio: 38,
			premium: 27.90,
			cat: 'bajera',
			modo: 'color',
			clase: 'ros',
			capa: 'bajera',
			imagen: 'Ros_Doble_Base.png'
		},
		{
			id: 94,
			parentid: 4,
			subparentid: null,
			defecto: false,
			nombre: 'Bajera ajustable algodón orgánico Azul Oscuro',
			sku: 'besto/180x200/azd',
			precio: 38,
			premium: 27.90,
			cat: 'bajera',
			modo: 'color',
			clase: 'azd',
			capa: 'bajera',
			imagen: 'Azd_Doble_Base.png'
		},
		{
			id: 95,
			parentid: 4,
			subparentid: null,
			defecto: false,
			nombre: 'Bajera ajustable algodón orgánico Gris Ceniza Oscuro',
			sku: 'besto/180x200/cen',
			precio: 38,
			premium: 27.90,
			cat: 'bajera',
			modo: 'color',
			clase: 'grz',
			capa: 'bajera',
			imagen: 'Grz_Doble_Base.png'
		},
		{
			id: 96,
			parentid: 4,
			subparentid: null,
			defecto: false,
			nombre: 'Bajera ajustable algodón orgánico Gris Piedra',
			sku: 'besto/180x200/pie',
			precio: 38,
			premium: 27.90,
			cat: 'bajera',
			modo: 'color',
			clase: 'pie',
			capa: 'bajera',
			imagen: 'Pie_Doble_Base.png'
		},
		{
			id: 97,
			parentid: 4,
			subparentid: null,
			defecto: false,
			nombre: 'Bajera ajustable algodón orgánico Azul',
			sku: 'besto/180x200/azc',
			precio: 38,
			premium: 27.90,
			cat: 'bajera',
			modo: 'color',
			clase: 'azc',
			capa: 'bajera',
			imagen: 'Azu_Doble_Base.png'
		},
		{
			id: 98,
			parentid: 4,
			subparentid: null,
			defecto: false,
			nombre: 'Bajera ajustable algodón orgánico Gris Ceniza',
			sku: 'besto/180x200/grz',
			precio: 38,
			premium: 27.90,
			cat: 'bajera',
			modo: 'color',
			clase: 'cen',
			capa: 'bajera',
			imagen: 'Grc_Doble_Base.png'
		},
		{
			id: 99,
			parentid: 4,
			subparentid: null,
			defecto: false,
			nombre: 'Bajera ajustable algodón orgánico Gris Claro',
			sku: 'besto/180x200/grc',
			precio: 38,
			premium: 27.90,
			cat: 'bajera',
			modo: 'color',
			clase: 'grc',
			capa: 'bajera',
			imagen: 'Grc_2_Doble_Base.png'
		},

		{
			id: 100,
			parentid: 4,
			subparentid: null,
			defecto: true,
			nombre: 'Sábana encimera algodón orgánico Blanco',
			sku: 'besto/270x275/bco',
			precio: 47,
			premium: 34.90,
			cat: 'encimera',
			modo: 'color',
			clase: 'bco',
			capa: 'encimera',
			imagen: 'Bco_Doble_Sabana.png'
		},

		{
			id: 1007,
			parentid: 4,
			subparentid: null,
			defecto: true,
			nombre: 'Sábana encimera algodón orgánico Verde Oscuro',
			sku: 'BESTO/270X275/VOS',
			precio: 39,
			premium: 34.90,
			cat: 'encimera',
			modo: 'color',
			clase: 'gre',
			capa: 'encimera',
			imagen: 'Dark_Green_Doble_Sabana.png'
		},

		{
			id: 1511,
			parentid: 4,
			subparentid: null,
			defecto: false,
			nombre: 'Sábana encimera algodón orgánico Lila Claro',
			sku: 'besto/270x275/mrr',
			precio: 44,
			premium: 39.99,
			cat: 'encimera',
			modo: 'color',
			clase: 'mrr',
			capa: 'encimera',
			imagen: 'Mar_Doble_Sabana.png'
		},

		{
			id: 101,
			parentid: 4,
			subparentid: null,
			defecto: false,
			nombre: 'Sábana encimera algodón orgánico Aqua',
			sku: 'besto/270x275/aqu',
			precio: 47,
			premium: 34.90,
			cat: 'encimera',
			modo: 'color',
			clase: 'aqu',
			capa: 'encimera',
			imagen: 'Agu_Doble_Sabana.png'
		},
		{
			id: 102,
			parentid: 4,
			subparentid: null,
			defecto: false,
			nombre: 'Sábana encimera algodón orgánico Amarillo',
			// sku: 'besto/270x275/ama',
			sku: 'besto/270x275/amc',
			precio: 47,
			premium: 34.90,
			cat: 'encimera',
			modo: 'color',
			clase: 'ama',
			capa: 'encimera',
			imagen: 'Amc_Doble_Sabana.png'
		},
		{
			id: 103,
			parentid: 4,
			subparentid: null,
			defecto: false,
			nombre: 'Sábana encimera algodón orgánico Rosa',
			sku: 'besto/270x275/ros',
			precio: 47,
			premium: 34.90,
			cat: 'encimera',
			modo: 'color',
			clase: 'ros',
			capa: 'encimera',
			imagen: 'Ros_Doble_Sabana.png'
		},
		{
			id: 104,
			parentid: 4,
			subparentid: null,
			defecto: false,
			nombre: 'Sábana encimera algodón orgánico Azul Oscuro',
			sku: 'besto/270x275/azd',
			precio: 47,
			premium: 34.90,
			cat: 'encimera',
			modo: 'color',
			clase: 'azd',
			capa: 'encimera',
			imagen: 'Azd_Doble_Sabana.png'
		},
		{
			id: 105,
			parentid: 4,
			subparentid: null,
			defecto: false,
			nombre: 'Sábana encimera algodón orgánico Gris Ceniza Oscuro',
			sku: 'besto/270x275/cen',
			precio: 47,
			premium: 34.90,
			cat: 'encimera',
			modo: 'color',
			clase: 'grz',
			capa: 'encimera',
			imagen: 'Grz_Doble_Sabana.png'
		},
		{
			id: 106,
			parentid: 4,
			subparentid: null,
			defecto: false,
			nombre: 'Sábana encimera algodón orgánico Gris Piedra',
			sku: 'besto/270x275/pie',
			precio: 47,
			premium: 34.90,
			cat: 'encimera',
			modo: 'color',
			clase: 'pie',
			capa: 'encimera',
			imagen: 'Pie_Doble_Sabana.png'
		},
		{
			id: 107,
			parentid: 4,
			subparentid: null,
			defecto: false,
			nombre: 'Sábana encimera algodón orgánico Azul',
			sku: 'besto/270x275/azu',
			precio: 47,
			premium: 34.90,
			cat: 'encimera',
			modo: 'color',
			clase: 'azu',
			capa: 'encimera',
			imagen: 'Azu_Doble_Sabana.png'
		},
		{
			id: 108,
			parentid: 4,
			subparentid: null,
			defecto: false,
			nombre: 'Sábana encimera algodón orgánico Gris Claro',
			sku: 'besto/270x275/grz',
			precio: 47,
			premium: 34.90,
			cat: 'encimera',
			modo: 'color',
			clase: 'cen',
			capa: 'encimera',
			imagen: 'Grc_Doble_Sabana.png'
		},
		{
			id: 109,
			parentid: 4,
			subparentid: null,
			defecto: true,
			nombre: 'Funda nórdica algodón orgánico Blanco',
			sku: 'besto/260x260/bco',
			precio: 75,
			premium: 54.90,
			cat: 'funda',
			modo: 'color',
			clase: 'bco',
			capa: 'funda',
			imagen: 'Bco_Doble_Nordico.png'
		},
		{
			id: 1003,
			parentid: 4,
			subparentid: null,
			defecto: true,
			nombre: 'Funda nórdica algodón orgánico Verde Oscuro',
			sku: 'BESTO/260X260/VOS',
			precio: 60,
			premium: 54.90,
			cat: 'funda',
			modo: 'color',
			clase: 'gre',
			capa: 'funda',
			imagen: 'Dark_Green_Doble_Nordico.png'
		},
		{
			id: 1507,
			parentid: 4,
			subparentid: null,
			defecto: false,
			nombre: 'Funda nórdica algodón orgánico Lila Claro',
			sku: 'bestobic/260x260/mrr',
			precio: 67,
			premium: 60.99,
			cat: 'funda',
			modo: 'color',
			clase: 'mrr',
			capa: 'funda',
			imagen: 'Mar_Doble_Nordico.png'
		},
		{
			id: 110,
			parentid: 4,
			subparentid: null,
			defecto: false,
			nombre: 'Funda nórdica algodón orgánico Aqua',
			sku: 'besto/260x260/aqu',
			precio: 75,
			premium: 54.90,
			cat: 'funda',
			modo: 'color',
			clase: 'aqu',
			capa: 'funda',
			imagen: 'Agu_Doble_Nordico.png'
		},
		{
			id: 111,
			parentid: 4,
			subparentid: null,
			defecto: false,
			nombre: 'Funda nórdica algodón orgánico Amarillo',
			// sku: 'besto/260x260/ama',
			sku: 'besto/260x260/amc',
			precio: 75,
			premium: 54.90,
			cat: 'funda',
			modo: 'color',
			clase: 'ama',
			capa: 'funda',
			imagen: 'Amc_Doble_Nordico.png'
		},
		{
			id: 112,
			parentid: 4,
			subparentid: null,
			defecto: false,
			nombre: 'Funda nórdica algodón orgánico Rosa',
			sku: 'besto/260x260/ros',
			precio: 75,
			premium: 54.90,
			cat: 'funda',
			modo: 'color',
			clase: 'ros',
			capa: 'funda',
			imagen: 'Ros_Doble_Nordico.png'
		},
		{
			id: 113,
			parentid: 4,
			subparentid: null,
			defecto: false,
			nombre: 'Funda nórdica algodón orgánico Azul Oscuro',
			sku: 'besto/260x260/azd',
			precio: 75,
			premium: 54.90,
			cat: 'funda',
			modo: 'color',
			clase: 'azd',
			capa: 'funda',
			imagen: 'Azd_Doble_Nordico.png'
		},
		{
			id: 114,
			parentid: 4,
			subparentid: null,
			defecto: false,
			nombre: 'Funda nórdica algodón orgánico Gris Ceniza',
			sku: 'besto/260x260/cen',
			precio: 75,
			premium: 54.90,
			cat: 'funda',
			modo: 'color',
			clase: 'grz',
			capa: 'funda',
			imagen: 'Grz_Doble_Nordico.png'
		},
		{
			id: 115,
			parentid: 4,
			subparentid: null,
			defecto: false,
			nombre: 'Funda nórdica algodón orgánico Gris Piedra',
			sku: 'bestobic/260x260/pie',
			precio: 75,
			premium: 54.90,
			cat: 'funda',
			modo: 'color',
			clase: 'piedoble',
			capa: 'funda',
			imagen: 'Pie_Doble_Nordico.png'
		},
		{
			id: 116,
			parentid: 4,
			subparentid: null,
			defecto: false,
			nombre: 'Funda nórdica algodón orgánico Azul',
			sku: 'bestobic/260x260/azc',
			precio: 75,
			premium: 54.90,
			cat: 'funda',
			modo: 'color',
			clase: 'azudoble',
			capa: 'funda',
			imagen: 'Azu_Doble_Nordico.png'
		},
		{
			id: 117,
			parentid: 4,
			subparentid: null,
			defecto: false,
			nombre: 'Funda nórdica algodón orgánico Gris Claro',
			sku: 'bestobic/260x260/grc',
			precio: 75,
			premium: 54.90,
			cat: 'funda',
			modo: 'color',
			clase: 'grcdoble',
			capa: 'funda',
			imagen: 'Grc_Doble_Nordico.png'
		},
		{
			id: 118,
			parentid: 1,
			subparentid: null,
			defecto: true,
			nombre: 'Funda almohada algodón orgánico Blanco',
			sku: 'besto1/45x110/bco',
			precio: 18,
			premium: 12.90,
			cat: 'almohada-45x110',
			modo: 'color',
			clase: 'bco',
			capa: 'almohada',
			imagen: 'Bco_Individual_Cojin.png'
		},
		{
			id: 1012,
			parentid: 1,
			subparentid: null,
			defecto: true,
			nombre: 'Funda almohada algodón orgánico Verde Oscuro',
			sku: 'BESTO/45X110/VOS',
			precio: 16,
			premium: 13.90,
			cat: 'almohada-45x110',
			modo: 'color',
			clase: 'gre',
			capa: 'almohada',
			imagen: 'Dark_Green_Individual_Cojin.png'
		},
		{
			id: 1512,
			parentid: 1,
			subparentid: null,
			defecto: false,
			nombre: 'Funda almohada algodón orgánico Lila Claro',
			sku: 'BESTO/45X110/MRR',
			precio: 18,
			premium: 15.99,
			cat: 'almohada-45x110',
			modo: 'color',
			clase: 'mrr',
			capa: 'almohada',
			imagen: 'Mar_Individual_Cojin.png'
		},
		{
			id: 119,
			parentid: 1,
			subparentid: null,
			defecto: false,
			nombre: 'Funda almohada algodón orgánico Aqua',
			sku: 'besto/45x110/aqu',
			precio: 18,
			premium: 12.90,
			cat: 'almohada-45x110',
			modo: 'color',
			clase: 'aqu',
			capa: 'almohada',
			imagen: 'Agu_Individual_Cojin.png'
		},
		{
			id: 120,
			parentid: 1,
			subparentid: null,
			defecto: false,
			nombre: 'Funda almohada algodón orgánico Amarillo',
			// sku: 'besto/45x110/ama',
			sku: 'besto/45x110/amc',
			precio: 18,
			premium: 12.90,
			cat: 'almohada-45x110',
			modo: 'color',
			clase: 'ama',
			capa: 'almohada',
			imagen: 'Amc_Individual_Cojin.png'
		},
		{
			id: 121,
			parentid: 1,
			subparentid: null,
			defecto: false,
			nombre: 'Funda almohada algodón orgánico Rosa',
			sku: 'besto/45x110/ros',
			precio: 18,
			premium: 12.90,
			cat: 'almohada-45x110',
			modo: 'color',
			clase: 'ros',
			capa: 'almohada',
			imagen: 'Ros_Individual_Cojin.png'
		},
		{
			id: 122,
			parentid: 1,
			subparentid: null,
			defecto: false,
			nombre: 'Funda almohada algodón orgánico Azul Oscuro',
			sku: 'besto/45x110/azd',
			precio: 18,
			premium: 12.90,
			cat: 'almohada-45x110',
			modo: 'color',
			clase: 'azd',
			capa: 'almohada',
			imagen: 'Azd_Individual_Cojin.png'
		},
		{
			id: 123,
			parentid: 1,
			subparentid: null,
			defecto: false,
			nombre: 'Funda almohada algodón orgánico Gris Ceniza Oscuro',
			sku: 'besto/45x110/cen',
			precio: 18,
			premium: 12.90,
			cat: 'almohada-45x110',
			modo: 'color',
			clase: 'grz',
			capa: 'almohada',
			imagen: 'Grz_Individual_Cojin.png'
		},
		{
			id: 124,
			parentid: 1,
			subparentid: null,
			defecto: false,
			nombre: 'Funda almohada algodón orgánico Gris Piedra',
			sku: 'besto/45x110/pie',
			precio: 18,
			premium: 12.90,
			cat: 'almohada-45x110',
			modo: 'color',
			clase: 'pie',
			capa: 'almohada',
			imagen: 'Pie_Individual_Cojin.png'
		},
		{
			id: 125,
			parentid: 1,
			subparentid: null,
			defecto: false,
			nombre: 'Funda almohada algodón orgánico Azul',
			sku: 'besto/45x110/azu',
			precio: 18,
			premium: 12.90,
			cat: 'almohada-45x110',
			modo: 'color',
			clase: 'azu',
			capa: 'almohada',
			imagen: 'Azu_Individual_Cojin.png'
		},
		{
			id: 126,
			parentid: 1,
			subparentid: null,
			defecto: false,
			nombre: 'Funda almohada algodón orgánico Gris Ceniza',
			sku: 'besto/45x110/grz',
			precio: 18,
			premium: 12.90,
			cat: 'almohada-45x110',
			modo: 'color',
			clase: 'cen',
			capa: 'almohada',
			imagen: 'Grc_Individual_Cojin.png'
		},
		{
			id: 127,
			parentid: 1,
			subparentid: null,
			defecto: false,
			nombre: 'Funda almohada algodón orgánico Gris Claro',
			sku: 'besto/45x110/grc',
			precio: 18,
			premium: 12.90,
			cat: 'almohada-45x110',
			modo: 'color',
			clase: 'grc',
			capa: 'almohada',
			imagen: 'Grc_2_Individual_Cojin.png'
		},
		{
			id: 128,
			parentid: 2,
			subparentid: null,
			defecto: true,
			nombre: 'Funda almohada algodón orgánico Blanco',
			sku: 'besto1/45X160/bco',
			precio: 19,
			premium: 13.90,
			cat: 'almohada-45x160',
			modo: 'color',
			clase: 'bco',
			capa: 'almohada',
			imagen: 'Bco_Doble_Largo.png'
		},

		{
			id: 1013,
			parentid: 2,
			subparentid: null,
			defecto: true,
			nombre: 'Funda almohada algodón orgánico Verde Oscuro',
			sku: 'BESTO/45X160/VOS',
			precio: 16,
			premium: 13.90,
			cat: 'almohada-45x160',
			modo: 'color',
			clase: 'gre',
			capa: 'almohada',
			imagen: 'Dark_Green_Doble_Largo.png'
		},
		{
			id: 1513,
			parentid: 2,
			subparentid: null,
			defecto: false,
			nombre: 'Funda almohada algodón orgánico Lila Claro',
			sku: 'besto/45x160/mrr',
			precio: 19,
			premium: 16.99,
			cat: 'almohada-45x160',
			modo: 'color',
			clase: 'mrr',
			capa: 'almohada',
			imagen: 'Mar_Doble_Largo.png'
		},

		{
			id: 129,
			parentid: 2,
			subparentid: null,
			defecto: false,
			nombre: 'Funda almohada algodón orgánico Aqua',
			sku: 'besto/45X160/aqu',
			precio: 19,
			premium: 13.90,
			cat: 'almohada-45x160',
			modo: 'color',
			clase: 'aqu',
			capa: 'almohada',
			imagen: 'Agu_Doble_Largo.png'
		},
		{
			id: 130,
			parentid: 2,
			subparentid: null,
			defecto: false,
			nombre: 'Funda almohada algodón orgánico Amarillo',
			// sku: 'besto/45X160/ama',
			sku: 'besto/45X160/amc',
			precio: 19,
			premium: 13.90,
			cat: 'almohada-45x160',
			modo: 'color',
			clase: 'ama',
			capa: 'almohada',
			imagen: 'Amc_Doble_Largo.png'
		},
		{
			id: 131,
			parentid: 2,
			subparentid: null,
			defecto: false,
			nombre: 'Funda almohada algodón orgánico Rosa',
			sku: 'besto/45X160/ros',
			precio: 19,
			premium: 13.90,
			cat: 'almohada-45x160',
			modo: 'color',
			clase: 'ros',
			capa: 'almohada',
			imagen: 'Ros_Doble_Largo.png'
		},
		{
			id: 132,
			parentid: 2,
			subparentid: null,
			defecto: false,
			nombre: 'Funda almohada algodón orgánico Azul Oscuro',
			sku: 'besto/45X160/azd',
			precio: 19,
			premium: 13.90,
			cat: 'almohada-45x160',
			modo: 'color',
			clase: 'azd',
			capa: 'almohada',
			imagen: 'Azd_Doble_Largo.png'
		},

		{
			id: 133,
			parentid: 2,
			subparentid: null,
			defecto: false,
			nombre: 'Funda almohada algodón orgánico Gris Ceniza Oscuro',
			sku: 'besto/45X160/cen',
			precio: 19,
			premium: 13.90,
			cat: 'almohada-45x160',
			modo: 'color',
			clase: 'grz',
			capa: 'almohada',
			imagen: 'Grz_Doble_Largo.png'
		},
		{
			id: 134,
			parentid: 2,
			subparentid: null,
			defecto: false,
			nombre: 'Funda almohada algodón orgánico Gris Piedra',
			sku: 'besto/45X160/pie',
			precio: 19,
			premium: 13.90,
			cat: 'almohada-45x160',
			modo: 'color',
			clase: 'pie',
			capa: 'almohada',
			imagen: 'Pie_Doble_Largo.png'
		},
		{
			id: 135,
			parentid: 2,
			subparentid: null,
			defecto: false,
			nombre: 'Funda almohada algodón orgánico Azul',
			sku: 'besto/45X160/azu',
			precio: 19,
			premium: 13.90,
			cat: 'almohada-45x160',
			modo: 'color',
			clase: 'azu',
			capa: 'almohada',
			imagen: 'Azu_Doble_Largo.png'
		},
		{
			id: 136,
			parentid: 2,
			subparentid: null,
			defecto: false,
			nombre: 'Funda almohada algodón orgánico Gris Ceniza',
			sku: 'besto/45X160/grz',
			precio: 19,
			premium: 13.90,
			cat: 'almohada-45x160',
			modo: 'color',
			clase: 'cen',
			capa: 'almohada',
			imagen: 'Grc_Doble_Largo.png'

		},
		{
			id: 137,
			parentid: 2,
			subparentid: null,
			defecto: false,
			nombre: 'Funda almohada algodón orgánico Gris Claro',
			sku: 'besto/45X160/grc',
			precio: 19,
			premium: 13.90,
			cat: 'almohada-45x160',
			modo: 'color',
			clase: 'grc',
			capa: 'almohada',
			imagen: 'Grc_2_Doble_Largo.png'

		},










		//ALMOHADA SET 2-50x85 - CAMA 135x140


		{
			id: 138,
			parentid: 2,
			subparentid: null,
			defecto: true,
			nombre: 'Funda almohada algodón orgánico',
			sku: 'BESTO/50X85/BCO',
			precio: 24,
			premium: 21.9,
			cat: 'almohada-2-50x85',
			modo: 'color',
			clase: 'bco',
			capa: 'almohada',
			imagen: 'Bco_Doble_Cojines.png'
		},
		{
			id: 139,
			parentid: 2,
			subparentid: null,
			defecto: true,
			nombre: 'Funda almohada algodón orgánico',
			sku: 'BESTO/50X85/VOS',
			precio: 24,
			premium: 21.9,
			cat: 'almohada-2-50x85',
			modo: 'color',
			clase: 'gre',
			capa: 'almohada',
			imagen: 'Dark_Green_Doble_Cojines.png'
		},
		{
			id: 1514,
			parentid: 2,
			subparentid: null,
			defecto: true,
			nombre: 'Funda almohada algodón Lila orgánico',
			sku: 'besto/50x85/mrr',
			precio: 28,
			premium: 24.99,
			cat: 'almohada-2-50x85',
			modo: 'color',
			clase: 'mrr',
			capa: 'almohada',
			imagen: 'Mar_Doble_Cojines.png'
		},
		{
			id: 140,
			parentid: 2,
			subparentid: null,
			defecto: true,
			nombre: 'Funda almohada algodón orgánico',
			sku: 'BESTO/50X85/AQU',
			precio: 24,
			premium: 21.9,
			cat: 'almohada-2-50x85',
			modo: 'color',
			clase: 'aqu',
			capa: 'almohada',
			imagen: 'Agu_Doble_Cojines.png'
		},

		{
			id: 141,
			parentid: 2,
			subparentid: null,
			defecto: true,
			nombre: 'Funda almohada algodón orgánico',
			// sku: 'BESTO/50X85/ama',
			sku: 'BESTO/50X85/amc',
			precio: 24,
			premium: 21.9,
			cat: 'almohada-2-50x85',
			modo: 'color',
			clase: 'ama',
			capa: 'almohada',
			imagen: 'Amc_Doble_Cojines.png'
		},


		{
			id: 142,
			parentid: 2,
			subparentid: null,
			defecto: true,
			nombre: 'Funda almohada algodón orgánico',
			sku: 'BESTO/50X85/ROS',
			precio: 24,
			premium: 21.9,
			cat: 'almohada-2-50x85',
			modo: 'color',
			clase: 'ros',
			capa: 'almohada',
			imagen: 'Ros_Doble_Cojines.png'
		},

		{
			id: 143,
			parentid: 2,
			subparentid: null,
			defecto: true,
			nombre: 'Funda almohada algodón orgánico',
			sku: 'BESTO/50X85/AZD',
			precio: 24,
			premium: 21.9,
			cat: 'almohada-2-50x85',
			modo: 'color',
			clase: 'azd',
			capa: 'almohada',
			imagen: 'Azd_Doble_Cojines.png'
		},
		{
			id: 144,
			parentid: 2,
			subparentid: null,
			defecto: true,
			nombre: 'Funda almohada algodón orgánico',
			sku: 'BESTO/50X85/GRZ',
			precio: 24,
			premium: 21.9,
			cat: 'almohada-2-50x85',
			modo: 'color',
			clase: 'grz',
			capa: 'almohada',
			imagen: 'Grz_Doble_Cojines.png'
		},


		{
			id: 145,
			parentid: 2,
			subparentid: null,
			defecto: true,
			nombre: 'Funda almohada algodón orgánico',
			sku: 'BESTO/50X85/PIE',
			precio: 24,
			premium: 21.9,
			cat: 'almohada-2-50x85',
			modo: 'color',
			clase: 'pie',
			capa: 'almohada',
			imagen: 'Pie_Doble_Cojines.png'
		},
		{
			id: 146,
			parentid: 2,
			subparentid: null,
			defecto: true,
			nombre: 'Funda almohada algodón orgánico',
			sku: 'BESTO/50X85/AZU',
			precio: 24,
			premium: 21.9,
			cat: 'almohada-2-50x85',
			modo: 'color',
			clase: 'azu',
			capa: 'almohada',
			imagen: 'Azu_Doble_Cojines.png'
		},
		{
			id: 147,
			parentid: 2,
			subparentid: null,
			defecto: true,
			nombre: 'Funda almohada algodón orgánico',
			sku: 'BESTO/50X85/CEN',
			precio: 24,
			premium: 21.9,
			cat: 'almohada-2-50x85',
			modo: 'color',
			clase: 'cen',
			capa: 'almohada',
			imagen: 'Grc_Doble_Cojines.png'
		},
		{
			id: 148,
			parentid: 2,
			subparentid: null,
			defecto: true,
			nombre: 'Funda almohada algodón orgánico',
			sku: 'BESTO/50X85/GRC',
			precio: 24,
			premium: 21.9,
			cat: 'almohada-2-50x85',
			modo: 'color',
			clase: 'grc',
			capa: 'almohada',
			imagen: 'Grc_2_Doble_Cojines.png'
		},


		//ALMOHADA SET 2-50x85 - CAMA 150x160


		{
			id: 1200,
			parentid: 3,
			subparentid: null,
			defecto: true,
			nombre: 'Funda almohada algodón orgánico',
			sku: 'BESTO/50X85/BCO',
			precio: 24,
			premium: 21.9,
			cat: 'almohada-2-50x85',
			modo: 'color',
			clase: 'bco',
			capa: 'almohada',
			imagen: 'Bco_Doble_Cojines.png'
		},
		{
			id: 1201,
			parentid: 3,
			subparentid: null,
			defecto: true,
			nombre: 'Funda almohada algodón orgánico',
			sku: 'BESTO/50X85/VOS',
			precio: 24,
			premium: 21.9,
			cat: 'almohada-2-50x85',
			modo: 'color',
			clase: 'gre',
			capa: 'almohada',
			imagen: 'Dark_Green_Doble_Cojines.png'
		},
		{
			id: 1515,
			parentid: 3,
			subparentid: null,
			defecto: true,
			nombre: 'Funda almohada algodón Lila orgánico',
			sku: 'besto/50x85/mrr',
			precio: 28,
			premium: 24.99,
			cat: 'almohada-2-50x85',
			modo: 'color',
			clase: 'mrr',
			capa: 'almohada',
			imagen: 'Mar_Doble_Cojines.png'
		},
		{
			id: 1202,
			parentid: 3,
			subparentid: null,
			defecto: true,
			nombre: 'Funda almohada algodón orgánico',
			sku: 'BESTO/50X85/AQU',
			precio: 24,
			premium: 21.9,
			cat: 'almohada-2-50x85',
			modo: 'color',
			clase: 'aqu',
			capa: 'almohada',
			imagen: 'Agu_Doble_Cojines.png'
		},

		{
			id: 1203,
			parentid: 3,
			subparentid: null,
			defecto: true,
			nombre: 'Funda almohada algodón orgánico',
			// sku: 'BESTO/50X85/ama',
			sku: 'BESTO/50X85/amc',
			precio: 24,
			premium: 21.9,
			cat: 'almohada-2-50x85',
			modo: 'color',
			clase: 'ama',
			capa: 'almohada',
			imagen: 'Amc_Doble_Cojines.png'
		},


		{
			id: 1204,
			parentid: 3,
			subparentid: null,
			defecto: true,
			nombre: 'Funda almohada algodón orgánico',
			sku: 'BESTO/50X85/ROS',
			precio: 24,
			premium: 21.9,
			cat: 'almohada-2-50x85',
			modo: 'color',
			clase: 'ros',
			capa: 'almohada',
			imagen: 'Ros_Doble_Cojines.png'
		},

		{
			id: 1205,
			parentid: 3,
			subparentid: null,
			defecto: true,
			nombre: 'Funda almohada algodón orgánico',
			sku: 'BESTO/50X85/AZD',
			precio: 24,
			premium: 21.9,
			cat: 'almohada-2-50x85',
			modo: 'color',
			clase: 'azd',
			capa: 'almohada',
			imagen: 'Azd_Doble_Cojines.png'
		},
		{
			id: 1206,
			parentid: 3,
			subparentid: null,
			defecto: true,
			nombre: 'Funda almohada algodón orgánico',
			sku: 'BESTO/50X85/GRZ',
			precio: 24,
			premium: 21.9,
			cat: 'almohada-2-50x85',
			modo: 'color',
			clase: 'grz',
			capa: 'almohada',
			imagen: 'Grz_Doble_Cojines.png'
		},


		{
			id: 1207,
			parentid: 3,
			subparentid: null,
			defecto: true,
			nombre: 'Funda almohada algodón orgánico',
			sku: 'BESTO/50X85/PIE',
			precio: 24,
			premium: 21.9,
			cat: 'almohada-2-50x85',
			modo: 'color',
			clase: 'pie',
			capa: 'almohada',
			imagen: 'Pie_Doble_Cojines.png'
		},
		{
			id: 1208,
			parentid: 3,
			subparentid: null,
			defecto: true,
			nombre: 'Funda almohada algodón orgánico',
			sku: 'BESTO/50X85/AZU',
			precio: 24,
			premium: 21.9,
			cat: 'almohada-2-50x85',
			modo: 'color',
			clase: 'azu',
			capa: 'almohada',
			imagen: 'Azu_Doble_Cojines.png'
		},
		{
			id: 1209,
			parentid: 3,
			subparentid: null,
			defecto: true,
			nombre: 'Funda almohada algodón orgánico',
			sku: 'BESTO/50X85/CEN',
			precio: 24,
			premium: 21.9,
			cat: 'almohada-2-50x85',
			modo: 'color',
			clase: 'cen',
			capa: 'almohada',
			imagen: 'Grc_Doble_Cojines.png'
		},
		{
			id: 1210,
			parentid: 3,
			subparentid: null,
			defecto: true,
			nombre: 'Funda almohada algodón orgánico',
			sku: 'BESTO/50X85/GRC',
			precio: 24,
			premium: 21.9,
			cat: 'almohada-2-50x85',
			modo: 'color',
			clase: 'grc',
			capa: 'almohada',
			imagen: 'Grc_2_Doble_Cojines.png'
		},




		//ALMOHADA SET 2-50x85 - CAMA 180x200


		{
			id: 1211,
			parentid: 4,
			subparentid: null,
			defecto: true,
			nombre: 'Funda almohada algodón orgánico',
			sku: 'BESTO/50X85/BCO',
			precio: 24,
			premium: 21.9,
			cat: 'almohada-2-50x85',
			modo: 'color',
			clase: 'bco',
			capa: 'almohada',
			imagen: 'Bco_Doble_Cojines.png'
		},
		{
			id: 1212,
			parentid: 4,
			subparentid: null,
			defecto: true,
			nombre: 'Funda almohada algodón orgánico',
			sku: 'BESTO/50X85/VOS',
			precio: 24,
			premium: 21.9,
			cat: 'almohada-2-50x85',
			modo: 'color',
			clase: 'gre',
			capa: 'almohada',
			imagen: 'Dark_Green_Doble_Cojines.png'
		},
		{
			id: 1516,
			parentid: 4,
			subparentid: null,
			defecto: true,
			nombre: 'Funda almohada algodón Lila orgánico',
			sku: 'besto/50x85/mrr',
			precio: 28,
			premium: 24.99,
			cat: 'almohada-2-50x85',
			modo: 'color',
			clase: 'mrr',
			capa: 'almohada',
			imagen: 'Mar_Doble_Cojines.png'
		},
		{
			id: 1213,
			parentid: 4,
			subparentid: null,
			defecto: true,
			nombre: 'Funda almohada algodón orgánico',
			sku: 'BESTO/50X85/AQU',
			precio: 24,
			premium: 21.9,
			cat: 'almohada-2-50x85',
			modo: 'color',
			clase: 'aqu',
			capa: 'almohada',
			imagen: 'Agu_Doble_Cojines.png'
		},

		{
			id: 1214,
			parentid: 4,
			subparentid: null,
			defecto: true,
			nombre: 'Funda almohada algodón orgánico',
			// sku: 'BESTO/50X85/ama',
			sku: 'BESTO/50X85/amc',
			precio: 24,
			premium: 21.9,
			cat: 'almohada-2-50x85',
			modo: 'color',
			clase: 'ama',
			capa: 'almohada',
			imagen: 'Amc_Doble_Cojines.png'
		},


		{
			id: 1215,
			parentid: 4,
			subparentid: null,
			defecto: true,
			nombre: 'Funda almohada algodón orgánico',
			sku: 'BESTO/50X85/ROS',
			precio: 24,
			premium: 21.9,
			cat: 'almohada-2-50x85',
			modo: 'color',
			clase: 'ros',
			capa: 'almohada',
			imagen: 'Ros_Doble_Cojines.png'
		},

		{
			id: 1216,
			parentid: 4,
			subparentid: null,
			defecto: true,
			nombre: 'Funda almohada algodón orgánico',
			sku: 'BESTO/50X85/AZD',
			precio: 24,
			premium: 21.9,
			cat: 'almohada-2-50x85',
			modo: 'color',
			clase: 'azd',
			capa: 'almohada',
			imagen: 'Azd_Doble_Cojines.png'
		},
		{
			id: 1217,
			parentid: 4,
			subparentid: null,
			defecto: true,
			nombre: 'Funda almohada algodón orgánico',
			sku: 'BESTO/50X85/GRZ',
			precio: 24,
			premium: 21.9,
			cat: 'almohada-2-50x85',
			modo: 'color',
			clase: 'grz',
			capa: 'almohada',
			imagen: 'Grz_Doble_Cojines.png'
		},


		{
			id: 1218,
			parentid: 4,
			subparentid: null,
			defecto: true,
			nombre: 'Funda almohada algodón orgánico',
			sku: 'BESTO/50X85/PIE',
			precio: 24,
			premium: 21.9,
			cat: 'almohada-2-50x85',
			modo: 'color',
			clase: 'pie',
			capa: 'almohada',
			imagen: 'Pie_Doble_Cojines.png'
		},
		{
			id: 1219,
			parentid: 4,
			subparentid: null,
			defecto: true,
			nombre: 'Funda almohada algodón orgánico',
			sku: 'BESTO/50X85/AZU',
			precio: 24,
			premium: 21.9,
			cat: 'almohada-2-50x85',
			modo: 'color',
			clase: 'azu',
			capa: 'almohada',
			imagen: 'Azu_Doble_Cojines.png'
		},
		{
			id: 1220,
			parentid: 4,
			subparentid: null,
			defecto: true,
			nombre: 'Funda almohada algodón orgánico',
			sku: 'BESTO/50X85/CEN',
			precio: 24,
			premium: 21.9,
			cat: 'almohada-2-50x85',
			modo: 'color',
			clase: 'cen',
			capa: 'almohada',
			imagen: 'Grc_Doble_Cojines.png'
		},


		{
			id: 1221,
			parentid: 4,
			subparentid: null,
			defecto: true,
			nombre: 'Funda almohada algodón orgánico',
			sku: 'BESTO/50X85/GRC',
			precio: 24,
			premium: 21.9,
			cat: 'almohada-2-50x85',
			modo: 'color',
			clase: 'grc',
			capa: 'almohada',
			imagen: 'Grc_2_Doble_Cojines.png'
		},

		{
			id: 158,
			parentid: 1,
			subparentid: null,
			defecto: true,
			nombre: 'Funda de cuadrante algodón orgánico Blanco',
			sku: 'besto/55x55/bco',
			precio: 16,
			premium: 11.90,
			cat: 'cuadrante_1',
			modo: 'color',
			clase: 'bco',
			capa: 'cuadrante_1',
			imagen: 'Bco_Individual_Cojin1.png'
		},
		{
			id: 159,
			parentid: 1,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Aqua',
			sku: 'besto/55x55/aqu',
			precio: 16,
			premium: 11.90,
			cat: 'cuadrante_1',
			modo: 'color',
			clase: 'aqu',
			capa: 'cuadrante_1',
			imagen: 'Agu_Individual_Cojin1.png'
		},
		{
			id: 160,
			parentid: 1,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Amarillo',
			// sku: 'besto/55x55/ama',
			sku: 'besto/55x55/amc',
			precio: 16,
			premium: 11.90,
			cat: 'cuadrante_1',
			modo: 'color',
			clase: 'ama',
			capa: 'cuadrante_1',
			imagen: 'Amc_Individual_Cojin1.png'
		},
		{
			id: 161,
			parentid: 1,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Rosa',
			sku: 'besto/55x55/ros',
			precio: 16,
			premium: 11.90,
			cat: 'cuadrante_1',
			modo: 'color',
			clase: 'ros',
			capa: 'cuadrante_1',
			imagen: 'Ros_Individual_Cojin1.png'
		},
		{
			id: 162,
			parentid: 1,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Azul Oscuro',
			sku: 'besto/55x55/azd',
			precio: 27,
			premium: 19.90,
			cat: 'cuadrante_1',
			modo: 'color',
			clase: 'azd',
			capa: 'cuadrante_1',
			imagen: 'Azd_Individual_Cojin1.png'
		},
		{
			id: 163,
			parentid: 1,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Gris Ceniza Oscuro',
			sku: 'besto/55x55/cen',
			precio: 16,
			premium: 11.90,
			cat: 'cuadrante_1',
			modo: 'color',
			clase: 'grz',
			capa: 'cuadrante_1',
			imagen: 'Grz_Individual_Cojin1.png'
		},
		{
			id: 164,
			parentid: 1,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Gris Piedra',
			sku: 'bestobic/55x55/pie',
			precio: 16,
			premium: 11.90,
			cat: 'cuadrante_1',
			modo: 'color',
			clase: 'piedoble',
			capa: 'cuadrante_1',
			imagen: 'Pie_Individual_Cojin1.png'
		},

		{
			id: 165,
			parentid: 1,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Azul',
			sku: 'bestobic/55x55/azu',
			precio: 27,
			premium: 19.90,
			cat: 'cuadrante_1',
			modo: 'color',
			clase: 'azudoble',
			capa: 'cuadrante_1',
			imagen: 'Azu_Individual_Cojin1.png'
		},

		{
			id: 166,
			parentid: 1,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Gris Claro',
			sku: 'bestobic/55x55/grc',
			precio: 16,
			premium: 11.90,
			cat: 'cuadrante_1',
			modo: 'color',
			clase: 'grcdoble',
			capa: 'cuadrante_1',
			imagen: 'Grc_2_Individual_Cojin1.png'
		},

		{
			id: 167,
			parentid: 2,
			subparentid: null,
			defecto: true,
			nombre: 'Funda de cuadrante algodón orgánico Blanco',
			sku: 'besto/55x55/bco',
			precio: 16,
			premium: 11.90,
			cat: 'cuadrante_1',
			modo: 'color',
			clase: 'bco',
			capa: 'cuadrante_1',
			imagen: 'Bco_Doble_Cojin1.png'
		},
		{
			id: 1020,
			parentid: 2,
			subparentid: null,
			defecto: true,
			nombre: 'Funda de cuadrante algodón orgánico Verde Oscuro',
			sku: 'BESTO/55X55/VOS',
			precio: 15,
			premium: 12.90,
			cat: 'cuadrante_1',
			modo: 'color',
			clase: 'gre',
			capa: 'cuadrante_1',
			imagen: 'Dark_Green_Doble_Cojin2.png'
		},
		{
			id: 1521,
			parentid: 2,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Lila Claro',
			sku: 'bestobic/55x55/mrr',
			precio: 18,
			premium: 15.99,
			cat: 'cuadrante_1',
			modo: 'color',
			clase: 'mrr',
			capa: 'cuadrante_1',
			imagen: 'Mar_Doble_Cojin1.png'
		},
		{
			id: 168,
			parentid: 2,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Aqua',
			sku: 'besto/55x55/aqu',
			precio: 16,
			premium: 11.90,
			cat: 'cuadrante_1',
			modo: 'color',
			clase: 'aqu',
			capa: 'cuadrante_1',
			imagen: 'Agu_Doble_Cojin1.png'
		},
		{
			id: 169,
			parentid: 2,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Amarillo',
			// sku: 'besto/55x55/ama',
			sku: 'besto/55x55/amc',
			precio: 16,
			premium: 11.90,
			cat: 'cuadrante_1',
			modo: 'color',
			clase: 'ama',
			capa: 'cuadrante_1',
			imagen: 'Amc_Doble_Cojin1.png'
		},
		{
			id: 170,
			parentid: 2,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Rosa',
			sku: 'besto/55x55/ros',
			precio: 16,
			premium: 11.90,
			cat: 'cuadrante_1',
			modo: 'color',
			clase: 'ros',
			capa: 'cuadrante_1',
			imagen: 'Ros_Doble_Cojin1.png'
		},
		{
			id: 171,
			parentid: 2,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Azul Oscuro',
			sku: 'besto/55x55/azd',
			precio: 27,
			premium: 19.90,
			cat: 'cuadrante_1',
			modo: 'color',
			clase: 'azd',
			capa: 'cuadrante_1',
			imagen: 'Azd_Doble_Cojin1.png'
		},
		{
			id: 172,
			parentid: 2,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Gris Ceniza Oscuro',
			sku: 'besto/55x55/cen',
			precio: 16,
			premium: 11.90,
			cat: 'cuadrante_1',
			modo: 'color',
			clase: 'grz',
			capa: 'cuadrante_1',
			imagen: 'Grz_Doble_Cojin1.png'
		},
		{
			id: 173,
			parentid: 2,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Gris Piedra',
			sku: 'bestobic/55x55/pie',
			precio: 16,
			premium: 11.90,
			cat: 'cuadrante_1',
			modo: 'color',
			clase: 'piedoble',
			capa: 'cuadrante_1',
			imagen: 'Pie_Doble_Cojin1.png'
		},


		{
			id: 174,
			parentid: 2,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Azul',
			sku: 'bestobic/55x55/azu',
			precio: 27,
			premium: 19.90,
			cat: 'cuadrante_1',
			modo: 'color',
			clase: 'azudoble',
			capa: 'cuadrante_1',
			imagen: 'Azu_Doble_Cojin1.png'
		},

		{
			id: 175,
			parentid: 2,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Gris Claro',
			sku: 'bestobic/55x55/grc',
			precio: 16,
			premium: 11.90,
			cat: 'cuadrante_1',
			modo: 'color',
			clase: 'grcdoble',
			capa: 'cuadrante_1',
			imagen: 'Grc_2_Doble_Cojin1.png'
		},
		{
			id: 176,
			parentid: 3,
			subparentid: null,
			defecto: true,
			nombre: 'Funda de cuadrante algodón orgánico Blanco',
			sku: 'besto/55x55/bco',
			precio: 16,
			premium: 11.90,
			cat: 'cuadrante_1',
			modo: 'color',
			clase: 'bco',
			capa: 'cuadrante_1',
			imagen: 'Bco_Doble_Cojin1.png'
		},
		{
			id: 1021,
			parentid: 3,
			subparentid: null,
			defecto: true,
			nombre: 'Funda de cuadrante algodón orgánico Verde Oscuro',
			sku: 'BESTO/55X55/VOS',
			precio: 15,
			premium: 12.90,
			cat: 'cuadrante_1',
			modo: 'color',
			clase: 'gre',
			capa: 'cuadrante_1',
			imagen: 'Dark_Green_Doble_Cojin1.png'
		},
		{
			id: 1525,
			parentid: 3,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Lila Claro',
			sku: 'bestobic/55x55/mrr',
			precio: 18,
			premium: 15.99,
			cat: 'cuadrante_1',
			modo: 'color',
			clase: 'mrr',
			capa: 'cuadrante_1',
			imagen: 'Mar_Doble_Cojin1.png'
		},
		{
			id: 177,
			parentid: 3,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Aqua',
			sku: 'besto/55x55/aqu',
			precio: 16,
			premium: 11.90,
			cat: 'cuadrante_1',
			modo: 'color',
			clase: 'aqu',
			capa: 'cuadrante_1',
			imagen: 'Agu_Doble_Cojin1.png'
		},
		{
			id: 178,
			parentid: 3,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Amarillo',
			// sku: 'besto/55x55/ama',
			sku: 'besto/55x55/amc',
			precio: 16,
			premium: 11.90,
			cat: 'cuadrante_1',
			modo: 'color',
			clase: 'ama',
			capa: 'cuadrante_1',
			imagen: 'Amc_Doble_Cojin1.png'
		},
		{
			id: 179,
			parentid: 3,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Rosa',
			sku: 'besto/55x55/ros',
			precio: 16,
			premium: 11.90,
			cat: 'cuadrante_1',
			modo: 'color',
			clase: 'ros',
			capa: 'cuadrante_1',
			imagen: 'Ros_Doble_Cojin1.png'
		},
		{
			id: 180,
			parentid: 3,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Azul Oscuro',
			sku: 'besto/55x55/azd',
			precio: 27,
			premium: 19.90,
			cat: 'cuadrante_1',
			modo: 'color',
			clase: 'azd',
			capa: 'cuadrante_1',
			imagen: 'Azd_Doble_Cojin1.png'
		},
		{
			id: 181,
			parentid: 3,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Gris Ceniza Oscuro',
			sku: 'besto/55x55/cen',
			precio: 16,
			premium: 11.90,
			cat: 'cuadrante_1',
			modo: 'color',
			clase: 'grz',
			capa: 'cuadrante_1',
			imagen: 'Grz_Doble_Cojin1.png'
		},
		{
			id: 182,
			parentid: 3,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Gris Piedra',
			sku: 'bestobic/55x55/pie',
			precio: 16,
			premium: 11.90,
			cat: 'cuadrante_1',
			modo: 'color',
			clase: 'piedoble',
			capa: 'cuadrante_1',
			imagen: 'Pie_Doble_Cojin1.png'
		},
		{
			id: 183,
			parentid: 3,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Azul',
			sku: 'bestobic/55x55/azu',
			precio: 27,
			premium: 19.90,
			cat: 'cuadrante_1',
			modo: 'color',
			clase: 'azudoble',
			capa: 'cuadrante_1',
			imagen: 'Azu_Doble_Cojin1.png'
		},

		{
			id: 184,
			parentid: 3,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Gris Claro',
			sku: 'bestobic/55x55/grc',
			precio: 16,
			premium: 11.90,
			cat: 'cuadrante_1',
			modo: 'color',
			clase: 'grcdoble',
			capa: 'cuadrante_1',
			imagen: 'Grc_2_Doble_Cojin1.png'
		},
		{
			id: 185,
			parentid: 4,
			subparentid: null,
			defecto: true,
			nombre: 'Funda de cuadrante algodón orgánico Blanco',
			sku: 'besto/55x55/bco',
			precio: 16,
			premium: 11.90,
			cat: 'cuadrante_1',
			modo: 'color',
			clase: 'bco',
			capa: 'cuadrante_1',
			imagen: 'Bco_Doble_Cojin1.png'
		},
		{
			id: 1022,
			parentid: 4,
			subparentid: null,
			defecto: true,
			nombre: 'Funda de cuadrante algodón orgánico Verde Oscuro',
			sku: 'BESTO/55X55/VOS',
			precio: 15,
			premium: 12.90,
			cat: 'cuadrante_1',
			modo: 'color',
			clase: 'gre',
			capa: 'cuadrante_1',
			imagen: 'Dark_Green_Doble_Cojin2.png'
		},
		{
			id: 1518,
			parentid: 4,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Lila Claro',
			sku: 'bestobic/55x55/mrr',
			precio: 18,
			premium: 15.99,
			cat: 'cuadrante_1',
			modo: 'color',
			clase: 'mrr',
			capa: 'cuadrante_1',
			imagen: 'Mar_Doble_Cojin1.png'
		},
		{
			id: 186,
			parentid: 4,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Aqua',
			sku: 'besto/55x55/aqu',
			precio: 16,
			premium: 11.90,
			cat: 'cuadrante_1',
			modo: 'color',
			clase: 'aqu',
			capa: 'cuadrante_1',
			imagen: 'Agu_Doble_Cojin1.png'
		},
		{
			id: 187,
			parentid: 4,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Amarillo',
			// sku: 'besto/55x55/ama',
			sku: 'besto/55x55/amc',
			precio: 16,
			premium: 11.90,
			cat: 'cuadrante_1',
			modo: 'color',
			clase: 'ama',
			capa: 'cuadrante_1',
			imagen: 'Amc_Doble_Cojin1.png'
		},
		{
			id: 188,
			parentid: 4,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Rosa',
			sku: 'besto/55x55/ros',
			precio: 16,
			premium: 11.90,
			cat: 'cuadrante_1',
			modo: 'color',
			clase: 'ros',
			capa: 'cuadrante_1',
			imagen: 'Ros_Doble_Cojin1.png'
		},
		{
			id: 189,
			parentid: 4,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Azul Oscuro',
			sku: 'besto/55x55/azd',
			precio: 27,
			premium: 19.90,
			cat: 'cuadrante_1',
			modo: 'color',
			clase: 'azd',
			capa: 'cuadrante_1',
			imagen: 'Azd_Doble_Cojin1.png'
		},
		{
			id: 190,
			parentid: 4,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Gris Ceniza Oscuro',
			sku: 'besto/55x55/cen',
			precio: 16,
			premium: 11.90,
			cat: 'cuadrante_1',
			modo: 'color',
			clase: 'grz',
			capa: 'cuadrante_1',
			imagen: 'Grz_Doble_Cojin1.png'
		},
		{
			id: 191,
			parentid: 4,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Gris Piedra',
			sku: 'bestobic/55x55/pie',
			precio: 16,
			premium: 11.90,
			cat: 'cuadrante_1',
			modo: 'color',
			clase: 'piedoble',
			capa: 'cuadrante_1',
			imagen: 'Pie_Doble_Cojin1.png'
		},
		{
			id: 192,
			parentid: 4,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Azul',
			sku: 'bestobic/55x55/azu',
			precio: 27,
			premium: 19.90,
			cat: 'cuadrante_1',
			modo: 'color',
			clase: 'azudoble',
			capa: 'cuadrante_1',
			imagen: 'Azu_Doble_Cojin1.png'
		},
		{
			id: 193,
			parentid: 4,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Gris Claro',
			sku: 'bestobic/55x55/grc',
			precio: 16,
			premium: 11.90,
			cat: 'cuadrante_1',
			modo: 'color',
			clase: 'grcdoble',
			capa: 'cuadrante_1',
			imagen: 'Grc_2_Doble_Cojin1.png'
		},
		{
			id: 194,
			parentid: 1,
			subparentid: null,
			defecto: true,
			nombre: 'Funda de cuadrante algodón orgánico Blanco',
			sku: 'besto/55x55/bco',
			precio: 16,
			premium: 11.90,
			cat: 'cuadrante_2',
			modo: 'color',
			clase: 'bco',
			capa: 'cuadrante_2',
			imagen: 'Bco_Individual_Cojin1.png'
		},
		{
			id: 1019,
			parentid: 1,
			subparentid: null,
			defecto: true,
			nombre: 'Funda de cuadrante algodón orgánico Verde Oscuro',
			sku: 'BESTO/55X55/VOS',
			precio: 15,
			premium: 12.90,
			cat: 'cuadrante_2',
			modo: 'color',
			clase: 'gre',
			capa: 'cuadrante_2',
			imagen: 'Dark_Green_Doble_Cojin2.png'
		},
		{
			id: 1522,
			parentid: 1,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Lila Claro',
			sku: 'bestobic/55x55/mrr',
			precio: 18,
			premium: 15.99,
			cat: 'cuadrante_2',
			modo: 'color',
			clase: 'mrr',
			capa: 'cuadrante_2',
			imagen: 'Mar_Individual_Cojin1.png'
		},
		{
			id: 195,
			parentid: 1,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Aqua',
			sku: 'besto/55x55/aqu',
			precio: 16,
			premium: 11.90,
			cat: 'cuadrante_2',
			modo: 'color',
			clase: 'aqu',
			capa: 'cuadrante_2',
			imagen: 'Agu_Individual_Cojin1.png'
		},
		{
			id: 196,
			parentid: 1,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Amarillo',
			// sku: 'besto/55x55/ama',
			sku: 'besto/55x55/amc',
			precio: 16,
			premium: 11.90,
			cat: 'cuadrante_2',
			modo: 'color',
			clase: 'ama',
			capa: 'cuadrante_2',
			imagen: 'Amc_Individual_Cojin1.png'
		},
		{
			id: 197,
			parentid: 1,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Rosa',
			sku: 'besto/55x55/ros',
			precio: 16,
			premium: 11.90,
			cat: 'cuadrante_2',
			modo: 'color',
			clase: 'ros',
			capa: 'cuadrante_2',
			imagen: 'Ros_Individual_Cojin1.png'
		},
		{
			id: 198,
			parentid: 1,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Azul Oscuro',
			sku: 'besto/55x55/azd',
			precio: 27,
			premium: 19.90,
			cat: 'cuadrante_2',
			modo: 'color',
			clase: 'azd',
			capa: 'cuadrante_2',
			imagen: 'Azd_Individual_Cojin1.png'
		},
		{
			id: 199,
			parentid: 1,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Gris Ceniza Oscuro',
			sku: 'besto/55x55/cen',
			precio: 16,
			premium: 11.90,
			cat: 'cuadrante_2',
			modo: 'color',
			clase: 'grz',
			capa: 'cuadrante_2',
			imagen: 'Grz_Individual_Cojin1.png'
		},


		{
			id: 200,
			parentid: 1,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Gris Piedra',
			sku: 'bestobic/55x55/pie',
			precio: 16,
			premium: 11.90,
			cat: 'cuadrante_2',
			modo: 'color',
			clase: 'piedoble',
			capa: 'cuadrante_2',
			imagen: 'Pie_Individual_Cojin1.png'
		},
		{
			id: 201,
			parentid: 1,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Azul',
			sku: 'bestobic/55x55/azu',
			precio: 27,
			premium: 19.90,
			cat: 'cuadrante_2',
			modo: 'color',
			clase: 'azudoble',
			capa: 'cuadrante_2',
			imagen: 'Azu_Individual_Cojin1.png'
		},

		{
			id: 202,
			parentid: 1,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Gris Claro',
			sku: 'bestobic/55x55/grc',
			precio: 16,
			premium: 11.90,
			cat: 'cuadrante_2',
			modo: 'color',
			clase: 'grcdoble',
			capa: 'cuadrante_2',
			imagen: 'Grc_2_Individual_Cojin1.png'
		},
		{
			id: 203,
			parentid: 2,
			subparentid: null,
			defecto: true,
			nombre: 'Funda de cuadrante algodón orgánico Blanco',
			sku: 'besto/55x55/bco',
			precio: 16,
			premium: 11.90,
			cat: 'cuadrante_2',
			modo: 'color',
			clase: 'bco',
			capa: 'cuadrante_2',
			imagen: 'Bco_Doble_Cojin2.png'
		},
		{
			id: 1018,
			parentid: 2,
			subparentid: null,
			defecto: true,
			nombre: 'Funda de cuadrante algodón orgánico Verde Oscuro',
			sku: 'BESTO/55X55/VOS',
			precio: 15,
			premium: 12.90,
			cat: 'cuadrante_2',
			modo: 'color',
			clase: 'gre',
			capa: 'cuadrante_2',
			imagen: 'Dark_Green_Doble_Cojin2.png'
		},
		{
			id: 1520,
			parentid: 2,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Lila Claro',
			sku: 'bestobic/55x55/mrr',
			precio: 18,
			premium: 15.99,
			cat: 'cuadrante_2',
			modo: 'color',
			clase: 'mrr',
			capa: 'cuadrante_2',
			imagen: 'Mar_Doble_Cojin2.png'
		},
		{
			id: 204,
			parentid: 2,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Aqua',
			sku: 'besto/55x55/aqu',
			precio: 16,
			premium: 11.90,
			cat: 'cuadrante_2',
			modo: 'color',
			clase: 'aqu',
			capa: 'cuadrante_2',
			imagen: 'Agu_Doble_Cojin2.png'
		},
		{
			id: 205,
			parentid: 2,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Amarillo',
			//sku: 'besto/55x55/ama',
			sku: 'besto/55x55/amc',
			precio: 16,
			premium: 11.90,
			cat: 'cuadrante_2',
			modo: 'color',
			clase: 'ama',
			capa: 'cuadrante_2',
			imagen: 'Amc_Doble_Cojin2.png'
		},
		{
			id: 206,
			parentid: 2,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Rosa',
			sku: 'besto/55x55/ros',
			precio: 16,
			premium: 11.90,
			cat: 'cuadrante_2',
			modo: 'color',
			clase: 'ros',
			capa: 'cuadrante_2',
			imagen: 'Ros_Doble_Cojin2.png'
		},
		{
			id: 207,
			parentid: 2,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Azul Oscuro',
			sku: 'besto/55x55/azd',
			precio: 27,
			premium: 19.90,
			cat: 'cuadrante_2',
			modo: 'color',
			clase: 'azd',
			capa: 'cuadrante_2',
			imagen: 'Azd_Doble_Cojin2.png'
		},
		{
			id: 208,
			parentid: 2,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Gris Ceniza Oscuro',
			sku: 'besto/55x55/cen',
			precio: 16,
			premium: 11.90,
			cat: 'cuadrante_2',
			modo: 'color',
			clase: 'grz',
			capa: 'cuadrante_2',
			imagen: 'Grz_Doble_Cojin2.png'
		},
		{
			id: 209,
			parentid: 2,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Gris Piedra',
			sku: 'bestobic/55x55/pie',
			precio: 16,
			premium: 11.90,
			cat: 'cuadrante_2',
			modo: 'color',
			clase: 'piedoble',
			capa: 'cuadrante_2',
			imagen: 'Pie_Doble_Cojin2.png'
		},
		{
			id: 210,
			parentid: 2,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Azul',
			sku: 'bestobic/55x55/azu',
			precio: 27,
			premium: 19.90,
			cat: 'cuadrante_2',
			modo: 'color',
			clase: 'azudoble',
			capa: 'cuadrante_2',
			imagen: 'Azu_Doble_Cojin2.png'
		},
		{
			id: 211,
			parentid: 2,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Gris Claro',
			sku: 'bestobic/55x55/grc',
			precio: 16,
			premium: 11.90,
			cat: 'cuadrante_2',
			modo: 'color',
			clase: 'grcdoble',
			capa: 'cuadrante_2',
			imagen: 'Grc_2_Doble_Cojin2.png'
		},
		{
			id: 212,
			parentid: 3,
			subparentid: null,
			defecto: true,
			nombre: 'Funda de cuadrante algodón orgánico Blanco',
			sku: 'besto/55x55/bco',
			precio: 16,
			premium: 11.90,
			cat: 'cuadrante_2',
			modo: 'color',
			clase: 'bco',
			capa: 'cuadrante_2',
			imagen: 'Bco_Doble_Cojin2.png'
		},
		{
			id: 1017,
			parentid: 3,
			subparentid: null,
			defecto: true,
			nombre: 'Funda de cuadrante algodón orgánico Verde Oscuro',
			sku: 'BESTO/55X55/VOS',
			precio: 15,
			premium: 12.90,
			cat: 'cuadrante_2',
			modo: 'color',
			clase: 'gre',
			capa: 'cuadrante_2',
			imagen: 'Dark_Green_Doble_Cojin2.png'
		},
		{
			id: 1519,
			parentid: 3,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Lila Claro',
			sku: 'bestobic/55x55/mrr',
			precio: 18,
			premium: 15.99,
			cat: 'cuadrante_2',
			modo: 'color',
			clase: 'mrr',
			capa: 'cuadrante_2',
			imagen: 'Mar_Doble_Cojin2.png'
		},
		{
			id: 213,
			parentid: 3,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Aqua',
			sku: 'besto/55x55/aqu',
			precio: 16,
			premium: 11.90,
			cat: 'cuadrante_2',
			modo: 'color',
			clase: 'aqu',
			capa: 'cuadrante_2',
			imagen: 'Agu_Doble_Cojin2.png'
		},
		{
			id: 214,
			parentid: 3,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Amarillo',
			//sku: 'besto/55x55/ama',
			sku: 'besto/55x55/amc',
			precio: 16,
			premium: 11.90,
			cat: 'cuadrante_2',
			modo: 'color',
			clase: 'ama',
			capa: 'cuadrante_2',
			imagen: 'Amc_Doble_Cojin2.png'
		},
		{
			id: 215,
			parentid: 3,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Rosa',
			sku: 'besto/55x55/ros',
			precio: 16,
			premium: 11.90,
			cat: 'cuadrante_2',
			modo: 'color',
			clase: 'ros',
			capa: 'cuadrante_2',
			imagen: 'Ros_Doble_Cojin2.png'
		},
		{
			id: 216,
			parentid: 3,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Azul Oscuro',
			sku: 'besto/55x55/azd',
			precio: 27,
			premium: 19.90,
			cat: 'cuadrante_2',
			modo: 'color',
			clase: 'azd',
			capa: 'cuadrante_2',
			imagen: 'Azd_Doble_Cojin2.png'
		},
		{
			id: 217,
			parentid: 3,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Gris Ceniza Oscuro',
			sku: 'besto/55x55/cen',
			precio: 16,
			premium: 11.90,
			cat: 'cuadrante_2',
			modo: 'color',
			clase: 'grz',
			capa: 'cuadrante_2',
			imagen: 'Grz_Doble_Cojin2.png'
		},
		{
			id: 218,
			parentid: 3,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Gris Piedra',
			sku: 'bestobic/55x55/pie',
			precio: 16,
			premium: 11.90,
			cat: 'cuadrante_2',
			modo: 'color',
			clase: 'piedoble',
			capa: 'cuadrante_2',
			imagen: 'Pie_Doble_Cojin2.png'
		},
		{
			id: 219,
			parentid: 3,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Azul',
			sku: 'bestobic/55x55/azu',
			precio: 27,
			premium: 19.90,
			cat: 'cuadrante_2',
			modo: 'color',
			clase: 'azudoble',
			capa: 'cuadrante_2',
			imagen: 'Azu_Doble_Cojin2.png'
		},
		{
			id: 220,
			parentid: 3,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Gris Claro',
			sku: 'bestobic/55x55/grc',
			precio: 16,
			premium: 11.90,
			cat: 'cuadrante_2',
			modo: 'color',
			clase: 'grcdoble',
			capa: 'cuadrante_2',
			imagen: 'Grc_2_Doble_Cojin2.png'
		},
		{
			id: 221,
			parentid: 4,
			subparentid: null,
			defecto: true,
			nombre: 'Funda de cuadrante algodón orgánico Blanco',
			sku: 'besto/55x55/bco',
			precio: 16,
			premium: 11.90,
			cat: 'cuadrante_2',
			modo: 'color',
			clase: 'bco',
			capa: 'cuadrante_2',
			imagen: 'Bco_Doble_Cojin2.png'
		},

		{
			id: 1016,
			parentid: 4,
			subparentid: null,
			defecto: true,
			nombre: 'Funda de cuadrante algodón orgánico Verde Oscuro',
			sku: 'BESTO/55X55/VOS',
			precio: 15,
			premium: 12.90,
			cat: 'cuadrante_2',
			modo: 'color',
			clase: 'gre',
			capa: 'cuadrante_2',
			imagen: 'Dark_Green_Doble_Cojin2.png'
		},

		{
			id: 1517,
			parentid: 4,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Lila Claro',
			sku: 'bestobic/55x55/mrr',
			precio: 18,
			premium: 15.99,
			cat: 'cuadrante_2',
			modo: 'color',
			clase: 'mrr',
			capa: 'cuadrante_2',
			imagen: 'Mar_Doble_Cojin2.png'
		},
		{
			id: 222,
			parentid: 4,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Aqua',
			sku: 'besto/55x55/aqu',
			precio: 16,
			premium: 11.90,
			cat: 'cuadrante_2',
			modo: 'color',
			clase: 'aqu',
			capa: 'cuadrante_2',
			imagen: 'Agu_Doble_Cojin2.png'
		},
		{
			id: 223,
			parentid: 4,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Amarillo',
			// sku: 'besto/55x55/ama',
			sku: 'besto/55x55/amc',
			precio: 16,
			premium: 11.90,
			cat: 'cuadrante_2',
			modo: 'color',
			clase: 'ama',
			capa: 'cuadrante_2',
			imagen: 'Amc_Doble_Cojin2.png'
		},
		{
			id: 224,
			parentid: 4,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Rosa',
			sku: 'besto/55x55/ros',
			precio: 16,
			premium: 11.90,
			cat: 'cuadrante_2',
			modo: 'color',
			clase: 'ros',
			capa: 'cuadrante_2',
			imagen: 'Ros_Doble_Cojin2.png'
		},
		{
			id: 225,
			parentid: 4,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Azul Oscuro',
			sku: 'besto/55x55/azd',
			precio: 27,
			premium: 19.90,
			cat: 'cuadrante_2',
			modo: 'color',
			clase: 'azd',
			capa: 'cuadrante_2',
			imagen: 'Azd_Doble_Cojin2.png'
		},
		{
			id: 226,
			parentid: 4,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Gris Ceniza Oscuro',
			sku: 'besto/55x55/cen',
			precio: 16,
			premium: 11.90,
			cat: 'cuadrante_2',
			modo: 'color',
			clase: 'grz',
			capa: 'cuadrante_2',
			imagen: 'Grz_Doble_Cojin2.png'
		},
		{
			id: 227,
			parentid: 4,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Gris Piedra',
			sku: 'bestobic/55x55/pie',
			precio: 16,
			premium: 11.90,
			cat: 'cuadrante_2',
			modo: 'color',
			clase: 'piedoble',
			capa: 'cuadrante_2',
			imagen: 'Pie_Doble_Cojin2.png'
		},
		{
			id: 228,
			parentid: 4,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Azul',
			sku: 'bestobic/55x55/azu',
			precio: 27,
			premium: 19.90,
			cat: 'cuadrante_2',
			modo: 'color',
			clase: 'azudoble',
			capa: 'cuadrante_2',
			imagen: 'Azu_Doble_Cojin2.png'
		},
		{
			id: 229,
			parentid: 4,
			subparentid: null,
			defecto: false,
			nombre: 'Funda de cuadrante algodón orgánico Gris Claro',
			sku: 'bestobic/55x55/grc',
			precio: 16,
			premium: 11.90,
			cat: 'cuadrante_2',
			modo: 'color',
			clase: 'grcdoble',
			capa: 'cuadrante_2',
			imagen: 'Grc_2_Doble_Cojin2.png'
		},


	]
	let shopifyProducts = [];
	const storefrontAccessToken = '88588d34f1dcd338ab2dba4cbb679068';
	const shopifyUrl = 'https://textura-interiors-b2c.myshopify.com/api/2024-01/graphql.json';

	// Function to fetch data from Shopify API
	async function fetchData(query) {
		try {
			const response = await fetch(shopifyUrl, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					'X-Shopify-Storefront-Access-Token': storefrontAccessToken,
				},
				body: JSON.stringify({ query }),
			});
			const data = await response.json();
			return data.data;
		} catch (error) {
			throw new Error('Error querying Shopify Storefront API: ' + error.message);
		}
	}

	// Function to process products
	function processProducts(products) {
		const shopifyProducts = [];

		products.forEach(product => {
			const variants = product.node.variants.edges;

			variants.forEach(variant => {
				const variantNodeId = variant.node.id;
				const variantBarcode = variant.node.barcode;
				const variantPrice = variant.node.price;
				const variantAvailable = variant.node.availableForSale;
				const variantTitle = variant.node.title;
				const variantProductTitle = variant.node.product.title;
				const variantProductHandle = variant.node.product.handle;
				const variantDescuento = variant.node.descuento;
				const variantPvpPremium = variant.node.pvpPremium;
				const variantPvpRebajado = variant.node.pvpRebajado;
				const variantId = variantNodeId.match(/\d+$/)[0];
				shopifyProducts.push({ variantId, sku: variantBarcode, price: variantPrice, title: variantTitle, variantProductTitle: variantProductTitle, variantProductHandle: variantProductHandle, available: variantAvailable, descuento: variantDescuento, pvpPremium: variantPvpPremium, pvpRebajado: variantPvpRebajado });
			});
		});
		//console.log(shopifyProducts);
		return shopifyProducts;
	}

	// Function to fetch and process products
	async function fetchAndProcessProducts(query, appendToShopifyProducts) {
		try {
			const data = await fetchData(query);
			const products = processProducts(data.collectionByHandle.products.edges);
			if (appendToShopifyProducts) {
				shopifyProducts = shopifyProducts.concat(products);
			} else {
				shopifyProducts = products;
			}
		} catch (error) {
			console.error(error);
		}
	}

	// Define GraphQL queries
	const graphqlQuery1 = `  {
        collectionByHandle(handle: "landings-disena-tu-cama-1") {
          products(first: 250) {
            edges {
              node {
                id
                variants (first: 100) {
                  edges {
                    node {
                      id
                      barcode
                      title
                      price {
                        amount
                        currencyCode
                     }
					 availableForSale
					 product {
					 	title
					 	handle
					 }
					 descuento: metafield(namespace: "custom", key: "descuento_doofinder") {
						value
						type
					  }
					 pvpPremium: metafield(namespace: "metadatos", key: "pvp_premium") {
						value
						type
					  }
					 pvpRebajado: metafield(namespace: "metadatos", key: "pvp_rebajado") {
						value
						type
					  }
                    }
                  }
                }
              }
            }
          }
        }
      }`;
	const graphqlQuery2 = `  {
        collectionByHandle(handle: "landings-disena-tu-cama-2") {
          products(first: 240) {
            edges {
              node {
                id
                variants (first: 100){
                  edges {
                    node {
                      id
                      barcode
                      title
                       price {
                        amount
                        currencyCode
                      }
					  availableForSale
					 product {
					 	title
					 	handle
					 }
					  descuento: metafield(namespace: "custom", key: "descuento_doofinder") {
						 value
						 type
					   }
					  pvpPremium: metafield(namespace: "metadatos", key: "pvp_premium") {
						 value
						 type
					   }
					  pvpRebajado: metafield(namespace: "metadatos", key: "pvp_rebajado") {
						 value
						 type
					   }
                    }
                  }
                }
              }
            }
          }
        }
      }`;

	fetchAndProcessProducts(graphqlQuery1, true)
		.then(() => {
			// Fetch and process products from second query and append to shopifyProducts
			return fetchAndProcessProducts(graphqlQuery2, true);
		})
		.then(() => {
			//CATEGORIAS
			mostrar_productos('cama', 'items1');
			mostrar_productos('bajera', 'items3');
			mostrar_productos('funda', 'items4');
			mostrar_productos('encimera', 'items5');
			mostrar_productos('cuadrante_2', 'items7');
			mostrar_productos('cuadrante_1', 'items8');
			mostrar_productos('almohada-45x110', 'items10');
			mostrar_productos('almohada-45x160', 'items11');

			mostrar_productos('almohada-2-50x85', 'items12');


			//PRIMERA CARGA
			jQuery(function () {


				if (typeof (get_params('a')) != 'undefined') {

					var arr = [];

					arr.push('#variacion-' + get_params('a'));
					arr.push('.subsquare.almohad.' + get_params('b'));
					arr.push('#variacion-' + get_params('c'));
					arr.push('.subsquare.arriba.' + get_params('d'));
					arr.push('#variacion-' + get_params('e'));
					arr.push('#variacion-' + get_params('f'));
					arr.push('.subsquare.cuadrante.' + get_params('g'));
					arr.push('#variacion-' + get_params('h'));

					if (get_params('i') != '') {
						arr.push('#variacion-' + get_params('i'));
					}

					jQuery.each(arr, function (index, value) {
						jQuery(value).trigger('click');
						buildVariant();
						calcular();
					});

					nexsteps(7);
					jQuery('#modalask .popcancel').trigger('click');

					jQuery('html').animate({
						scrollTop: 0
					}, 1000);

				} else {

					jQuery('.square-item.PID-3').trigger('click');
					jQuery('.arriba.' + arriba).trigger('click');
					jQuery('.subsquare.cuadrante_1').trigger('click');


					jQuery('.variacion.selected').each(function () {
						cliquear(jQuery(this).attr('identificador'));
						buildVariant();
						calcular();
					});

				}



			});
		});


	//COLOR POR DEFECTO
	//PARTE DE ARRIBA:  ENCIMERA , FUNDA
	//CUADRANTE:  CUANDRANTE_0 , CUANDRANTE_1, CUANDRANTE_2

	const color = 'bco';
	const arriba = 'funda';

	const listado_almohadas = [
		{
			parent: 1,
			cat: 'almohada-45x110',
			defecto: true,
			mensaje: 'Incluye 1 ud. Tamaño ideal para tu ancho de cama'
		},
		{
			parent: 2,
			cat: 'almohada-45x160',
			defecto: true,
			mensaje: 'Incluye 1 ud. Tamaño ideal para tu ancho de cama'
		},
		{
			parent: 2,
			cat: 'almohada-2-50x85',
			defecto: false,
			mensaje: 'Incluye 1 Set de 2 - 50x85cm.'
		},
		{
			parent: 3,
			cat: 'almohada-2-50x85',
			defecto: true,
			mensaje: 'Incluye 1 Set de 2 - 50x85cm.'
		},
		{
			parent: 4,
			cat: 'almohada-2-50x85',
			defecto: true,
			mensaje: 'Incluye 1 Set de 2 - 50x85cm.'
		}

	];








	//GET URL PARAMS
	function get_params(param) {

		var page_uri = window.location.search.substring(1);
		var data_var = page_uri.split('&');

		for (var i = 0; i < data_var.length; i++) {
			var parameterName = data_var[i].split('=');
			if (parameterName[0] == param) {
				return parameterName[1];
			}
		}
	}



	function dibujar() {

		//IMAGENES
		jQuery('.capa').html('');

		jQuery('.variacion.color-item.selected').each(function () {
			var capa = jQuery(this).attr('capa');
			var base = 'https://cdn.shopify.com/s/files/1/0672/2804/1434/files/';
			var img = jQuery(this).attr('img-data');
			if (img.length != 0) {

				jQuery('.capa.' + capa).html('<img src="' + base + img + '">');

			}
		});


		if (screen.width <= 768) {
			// changeImgWidth();
		} else {

			var padre = jQuery('#img_personalizado').innerWidth();
			var nimage = parseInt((padre * 80) / 100);
			var pright = parseInt((padre - nimage) / 2);

			jQuery('#img_personalizado img').css('margin-left', pright + 'px');
			jQuery('#sharepop').css('margin-left', pright + 'px');
		}
	}


	function mostrar_productos(categoria, zona) {

		// Iterate through shopifyProducts and update listado_productos
		// Merge de arrays : necessitem el product ID de Shopi per fer l'add to cart
		shopifyProducts.forEach(shopifyItem => {
			//console.log(shopifyItem);
			const indices = listado_productos.reduce((acc, item, index) => {
				if (item.sku && item.sku.toLowerCase() === shopifyItem.sku.toLowerCase()) {
					acc.push(index);
				}
				return acc;
			}, []);

			// Update all matching items in listado_productos
			for (const index of indices) {
				listado_productos[index] = { ...listado_productos[index], ...shopifyItem };
			}
		})

		for (var info of listado_productos) {


			var variantId = 'variantId="' + info['variantId'] + '"';
			var available = 'available="' + info['available'] + '"';
			var variantProductHandle = 'variant-handle="' + info['variantProductHandle'] + '"';
			var variantProductTitle = 'variant-title="' + info['variantProductTitle'] + '"';
			if (info['cat'] == categoria) {

				var defecto = '';
				if (info['defecto'] === true) {
					var defecto = 'selected';
				}

				var pid = 'PID="PID-' + info['parentid'] + '"';
				var clase = info['clase'] + ' ' + defecto + ' ' + categoria + ' PID-' + info['parentid'] + '"';
				var variacion = 'id="variacion-' + info['id'] + '"';
				var identificador = 'identificador="' + info['id'] + '"';
				var cat = 'cat="' + categoria + '"';
				var sku = 'sku="' + info['sku'] + '"';
				var variantId = 'variantId="' + info['variantId'] + '"';
				var available = 'available="' + info['available'] + '"';
				var variantProductHandle = 'variant-handle="' + info['variantProductHandle'] + '"';
				var variantProductTitle = 'variant-title="' + info['variantProductTitle'] + '"';
				var img = 'img-data="' + info['imagen'] + '"';
				var capa = 'capa="' + info['capa'] + '"';
				var parent = info['parentid'];

				var data = '<div id="producto-' + info['id'] + '"' + identificador + ' class="producto" >';

				if (info['modo'] == 'color') {
					data += '<div ' + variacion + identificador + pid + cat + sku + variantId + variantProductTitle + variantProductHandle + available + img + capa + '" class="variacion color-item ' + clase + '"></div>';
				}
				if (info['modo'] == 'square') {
					data += '<div ' + variacion + identificador + cat + sku + variantId + variantProductTitle + variantProductHandle + available + img + capa + ' class="square-item ' + clase + '">' + info['nombre'] + '</div>';
				}

				data += '</div>';

				jQuery('#' + zona).append(data);

			}
		}
	}





	function cliquear(obj) {
		if (typeof obj === undefined) { return; }
		jQuery('#variacion-' + obj).trigger('click');
	}





	jQuery(document).on("click", ".square-item", function (event) {

		event.preventDefault();
		jQuery('.square-item').removeClass('selected');
		jQuery(this).addClass('selected');

		jQuery('.square-item').each(function () {
			if (jQuery(this).hasClass('selected')) {
				jQuery('.PID-' + jQuery(this).attr('identificador')).addClass('active');
				jQuery('.PID-' + jQuery(this).attr('identificador')).removeClass('remove');
			} else {
				jQuery('.PID-' + jQuery(this).attr('identificador')).addClass('remove');
				jQuery('.PID-' + jQuery(this).attr('identificador')).removeClass('active');
			}
		});


		//COLORES
		jQuery('.color-item').removeClass('selected');
		jQuery('.variacion.color-item.' + color + '.active').addClass('selected');


		//ALMOHADAS
		jQuery('.almohad').addClass('invalid');
		jQuery('.almohad, .subsquare.almohad').removeClass('selected');
		jQuery('.itemline.almohadas').css('display', 'none');


		var parent = jQuery('#items1 .selected').attr('identificador');
		for (var info of listado_almohadas) {

			if (parent == info['parent']) {
				jQuery('.almohad.' + info['cat']).removeClass('invalid');

				if (info['defecto'] === true) {
					jQuery('.almohad.' + info['cat']).addClass('selected');
					jQuery('.itemline.almohadas.' + info['cat']).css('display', 'flex');
					// generate_msg(info['mensaje']);
					jQuery('.almohad.' + info['cat']).trigger('click')

				} else {
					jQuery('.' + info['cat'] + '.PID-' + info['parent']).css('display', 'hidden');
					jQuery('.' + info['cat'] + '.PID-' + info['parent']).removeClass('active selected');
				}
			}
		}


		if (jQuery('#items1 .selected').attr('identificador') == 1) {
			jQuery('.subsquare.cuadrante.cuadrante_1').trigger('click');
			jQuery('#items7').css('display', 'flex');
			jQuery('.variacion.color-item.cuadrante_1').removeClass('selected');
			jQuery('.subsquare.cuadrante.cuadrante_2').css('display', 'none');

		} else {
			jQuery('.subsquare.cuadrante.cuadrante_1').trigger('click');
			jQuery('.subsquare.cuadrante.cuadrante_2').css('display', 'block');
		}

		jQuery('.arriba.' + arriba).trigger('click');

	});







	jQuery(document).on("click", ".almohad", function (event) {
		event.preventDefault();

		if (jQuery(this).hasClass('invalid')) {
			// generate_msg('<span class="unactive-grey">Medida no disponible para este ancho de cama</span>');
			return;

		} else {

			var parent = jQuery('#items1 .selected').attr('identificador');
			var msg = '';
			for (var info of listado_almohadas) {

				if (parent == info['parent']) {
					if (info['cat'] == jQuery(this).attr('cat')) {
						msg = info['mensaje'];
					}
				}
			}
			// generate_msg(msg);
		}

		jQuery('.almohad, .itemline.almohadas .variacion, .subsquare.almohad').removeClass('selected');
		jQuery('.itemline.almohadas').css('display', 'none');
		jQuery(this).addClass('selected');

		var parent = jQuery('#items1 .selected').attr('identificador');

		jQuery('.almohad.' + jQuery(this).attr('cat')).addClass('selected');
		jQuery('.itemline.almohadas.' + jQuery(this).attr('cat')).css('display', 'flex');

		var scolor = '.variacion.color-item.' + color + '.' + jQuery(this).attr('cat') + '.PID-' + parent;
		jQuery(scolor).addClass('selected');
		jQuery(scolor).addClass('selected').trigger('click');


		buildVariant();
		calcular();

	});






	jQuery(document).on("click", ".arriba", function (event) {
		event.preventDefault();

		jQuery('#items4, #items5').css('display', 'none');
		jQuery('#items4 .variacion, #items5 .variacion').removeClass('selected');

		jQuery('.subsquare.arriba').removeClass('selected');
		jQuery('.itemline.' + jQuery(this).attr('cat')).css('display', 'flex');
		jQuery('.subsquare.' + jQuery(this).attr('cat')).addClass('selected');

		if (jQuery(this).attr('cat') == 'encimera') {
			jQuery('#items4 .color-item.' + color + '.active').addClass('selected');
		} else {
			jQuery('#items5 .color-item.' + color + '.active').addClass('selected');
		}

		dibujar();
		buildVariant();
		calcular();
	});






	jQuery(document).on("click", ".cuadrante", function (event) {
		event.preventDefault();

		jQuery('#items7, #items8').css('display', 'none');
		jQuery('.subsquare.cuadrante').removeClass('selected');
		jQuery('.itemline.' + jQuery(this).attr('cat')).css('display', 'flex');
		jQuery('.subsquare.' + jQuery(this).attr('cat')).addClass('selected');

		var parent = jQuery('#items1 .selected').attr('identificador');


		jQuery('.variacion.color-item.cuadrante_1').removeClass('selected');
		jQuery('.variacion.color-item.cuadrante_2').removeClass('selected');

		if (jQuery(this).attr('cat') == 'cuadrante_0') {
			jQuery('.variacion.color-item.cuadrante_1, .variacion.color-item.cuadrante_2').removeClass('selected');
			jQuery('#desglose .current.cuadrante').html('Nada');
		}

		if (jQuery(this).attr('cat') == 'cuadrante_1') {
			jQuery('#items7').css('display', 'flex');
			jQuery('.variacion.color-item.cuadrante_2.' + color + '.active').addClass('selected').trigger('click');

		}


		if (jQuery(this).attr('cat') == 'cuadrante_2') {
			jQuery('#items7, #items8').css('display', 'flex');
			jQuery('.variacion.color-item.cuadrante_1.' + color + '.active').addClass('selected').trigger('click');
			jQuery('.variacion.color-item.cuadrante_2.' + color + '.active').addClass('selected').trigger('click');
		}



		dibujar();
		buildVariant();
		calcular();

	});







	jQuery(document).on("click", ".variacion", function (event) {
		event.preventDefault();

		var cat = jQuery(this).attr('cat');
		jQuery('.variacion.color-item.' + cat).removeClass('selected');
		jQuery(this).addClass('selected');


		buildVariant();
		calcular();
		dibujar();
	});








	function calcular() {

		let total = 0;
		let totalpremium = 0;

		jQuery('.variacion.selected').each(function () {
			let actual = jQuery(this).attr('identificador');

			var miItem = listado_productos.filter(function (itemBaseDatos) {

				return itemBaseDatos['id'] == actual;
			});

			if (miItem[0]['price']) {
				total = total + parseFloat(miItem[0]['price'].amount);
			}
			if (miItem[0]['descuento']) {
				if (miItem[0]['descuento'].value === false) {
					let pvpPremiumValue = JSON.parse(miItem[0]['pvpPremium'].value)
					if (pvpPremiumValue) {
						totalpremium = totalpremium + parseFloat(pvpPremiumValue.amount);
					}
				} else {
					let pvpRebajadoValue = JSON.parse(miItem[0]['pvpRebajado'].value)
					if (pvpRebajadoValue) {
						totalpremium = totalpremium + parseFloat(pvpRebajadoValue.amount);
					}
				}
			}

		});

		jQuery('#totalproduct-normal').html(total.toFixed(0) + '€');
		jQuery('#totalproduct-premium ').html(totalpremium.toFixed(2) + '€<br/><span class="premium">PREMIUM</spam>');

	}








	jQuery(document).on("click", ".cuadrante", function (event) {
		event.preventDefault();

		jQuery('#items7, #items8').css('display', 'none');
		jQuery('.subsquare.cuadrante').removeClass('selected');
		jQuery('.itemline.' + jQuery(this).attr('cat')).css('display', 'flex');
		jQuery('.subsquare.' + jQuery(this).attr('cat')).addClass('selected');

		var parent = jQuery('#items1 .selected').attr('identificador');


		jQuery('.variacion.color-item.cuadrante_1').removeClass('selected');
		jQuery('.variacion.color-item.cuadrante_2').removeClass('selected');

		if (jQuery(this).attr('cat') == 'cuadrante_0') {
			jQuery('.variacion.color-item.cuadrante_1, .variacion.color-item.cuadrante_2').removeClass('selected');
			jQuery('#desglose .current.cuadrante').html('Nada');
		}

		if (jQuery(this).attr('cat') == 'cuadrante_1') {
			jQuery('#items7').css('display', 'flex');
			jQuery('.variacion.color-item.cuadrante_2.' + color + '.active').addClass('selected').trigger('click');

		}


		if (jQuery(this).attr('cat') == 'cuadrante_2') {
			jQuery('#items7, #items8').css('display', 'flex');
			jQuery('.variacion.color-item.cuadrante_1.' + color + '.active').addClass('selected').trigger('click');
			jQuery('.variacion.color-item.cuadrante_2.' + color + '.active').addClass('selected').trigger('click');
		}



		dibujar();
		buildVariant();
		calcular();
		// variantId()

	});

	function buildVariant() {
		var variantArray = [];

		jQuery('.variacion.selected').each(function () {

			let actual = jQuery(this).attr('identificador');
			let variant = jQuery(this).attr('variantId');

			// Filtrar el array por 'variantId'
			var miItemByVariant = listado_productos.filter(function (itemBaseDatos) {
				return itemBaseDatos['variantId'] == variant;
			});

			// Comprobar si hay elementos después de los filtros y añadirlos al array
			if (miItemByVariant.length > 0 && typeof variant !== 'undefined') {
				variantArray.push(miItemByVariant[0]);
			}

			// Limpiar el contenido actual de #variantId
			jQuery('#variantId').empty();
			jQuery('.soldoutproduct').empty();

			//Enable button añadir a la bolsa
			jQuery('.product-form__submit').removeClass('disabled-button-carrito');

			// Texto original del botón añadir a la bolsa
			var originalText = 'Añadir a la bolsa'
			jQuery('.product-form__submit').text(originalText);

			// Añadir inputs al elemento con id 'variantId' para cada elemento en variantArray
			variantArray.forEach(function (item) {
				if (item.available) {
					var inputElement = '<input class="hidden" type="text" value="' + item.variantId + '">';
					jQuery('#variantId').append(inputElement);
				} else {
					jQuery('.alert-block').addClass('toggleAlert');
					var product = item.variantProductTitle
					jQuery('.soldoutproduct').append('<div class="so-line"><div class="product-soldout-wrapper"><h3><a href="/products/' + item.variantProductHandle + '">' + item.variantProductTitle + '</a> está agotado.</h3></div>');
					jQuery('.product-form__submit').text('Agotado');
					jQuery('.product-form__submit').addClass('disabled-button-carrito');
				}
			});
		});

	}

	jQuery(document).on("click", ".variacion", function (event) {
		event.preventDefault();


		var colores = new Array();
		colores["ama"] = 'Amarillo';
		colores["bco"] = 'Blanco';
		colores["cen"] = 'Ceniza';
		colores["azd"] = 'Azul oscuro';
		colores["azu"] = 'Azul';
		// colores["lic"] = 'Lila';
		colores["aqu"] = 'Agua marina';
		colores["ros"] = 'Rosa';
		colores["gre"] = 'Verde oscuro';
		colores["grz"] = 'Gris ceniza oscuro';
		colores["cen"] = 'Gris ceniza';
		colores["grc"] = 'Gris claro';
		colores["pie"] = 'Gris piedra';
		colores["mrr"] = 'Marron';
		colores["piedoble"] = 'Gris piedra';
		colores["azudoble"] = 'Azul';
		colores["grcdoble"] = 'Gris ceniza';


		jQuery('#desglose .current.cama').html(jQuery('.square-item.selected').html());
		jQuery('#desglose .current.almohada').html(jQuery('.subsquare.almohad.selected').html());

		var nsabana = jQuery('.variacion.color-item.bajera.selected').attr('identificador');
		let nsabana_color = '';
		jQuery('.variacion.color-item.bajera.selected').each(function () {
			var miItem = listado_productos.filter(function (itemBaseDatos) {
				return itemBaseDatos['id'] == nsabana;
			});

			nsabana_color = miItem[0]['clase'];
		});
		jQuery('#desglose .current.sabana').html(colores[nsabana_color]);



		var nencimera = jQuery('.topper .variacion.color-item.selected').attr('identificador');
		let nencimera_color = '';
		jQuery('.topper .variacion.color-item.selected').each(function () {
			var miItem = listado_productos.filter(function (itemBaseDatos) {
				return itemBaseDatos['id'] == nencimera;
			});

			nencimera_color = miItem[0]['clase'];
		});

		var currcat = jQuery('.subsquare.arriba.selected').attr('cat');
		if (currcat == 'encimera') {
			var ncurrcat = '( F. Nórdica )';
		}

		if (currcat == 'funda') {
			var ncurrcat = '( Sábana )';
		}

		jQuery('#desglose .current.encimera').html(ncurrcat + ' ' + colores[nencimera_color]);



		var nfunda = jQuery('.itemline.almohadas .color-item.selected').attr('identificador');
		let nfunda_color = '';
		jQuery('.variacion.color-item.selected').each(function () {
			var miItem = listado_productos.filter(function (itemBaseDatos) {
				return itemBaseDatos['id'] == nfunda;
			});

			nfunda_color = miItem[0]['clase'];
		});

		jQuery('#desglose .current.funda').html(colores[nfunda_color]);




		var cuadrante_a = jQuery('#items7 .color-item.selected').attr('identificador');
		let cuadrante_a_color = '';
		jQuery('#items7 .color-item.selected').each(function () {
			var miItem = listado_productos.filter(function (itemBaseDatos) {
				return itemBaseDatos['id'] == cuadrante_a;
			});

			cuadrante_a_color = miItem[0]['clase'];
		});


		var cuadrante_b = jQuery('#items8 .color-item.selected').attr('identificador');
		let cuadrante_b_color = '';
		jQuery('#items8 .color-item.selected').each(function () {
			var miItem = listado_productos.filter(function (itemBaseDatos) {
				return itemBaseDatos['id'] == cuadrante_b;
			});

			cuadrante_b_color = miItem[0]['clase'];
		});



		if (cuadrante_a_color && !cuadrante_b_color) {
			var desglose_cuadrantes = '( 1 ) ' + colores[cuadrante_a_color];
		}

		if (!cuadrante_a_color && cuadrante_b_color) {
			var desglose_cuadrantes = '( 1 ) ' + colores[cuadrante_b_color];
		}

		if (cuadrante_a_color && cuadrante_b_color) {
			var desglose_cuadrantes = '( 2 ) ' + colores[cuadrante_a_color] + ' ' + colores[cuadrante_b_color];
		}

		jQuery('#desglose .current.cuadrante').html(desglose_cuadrantes);


		let psku = '';
		let pqty = '';
		var vcart = '';
		var url_redirect = 'https://www.textura-interiors.com/checkout/cart';
		var quickcart = 'https://www.textura-interiors.com//quickaddtocart';


		buildVariant();

		vcart += '<form id="scart" action=""​>';
		vcart += '<input id="skus" type="hidden" name="skus" value="" />';
		vcart += '<input id="skus" type="hidden" name="skus" value="" />';
		vcart += '<input id="qtys" type="hidden" name="qtys" value="" />';
		vcart += '<input type="hidden" name="url_redirect" id="url_redirect" value="https://www.textura-interiors.com/checkout/cart"/>';
		vcart += '<button type="submit" class="btn btn-primary botones">Ir al carrito</button>';
		vcart += '</form>';

		jQuery('#carrito').html(vcart);

		psku = psku.substring(0, psku.length - 1);
		pqty = pqty.substring(0, pqty.length - 1);

		jQuery('#scart #skus').val(psku);
		jQuery('#scart #qtys').val(pqty);
		jQuery('#scart').attr('action', quickcart + '?skus=' + psku + '&qtys=' + pqty + '&redirect_url=' + url_redirect);

	});





	jQuery(document).on("click", "#nbolsa", function (event) {
		event.preventDefault();

		jQuery('#scart').trigger('submit');

	});


});